var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _vm.value.showPickupStation &&
      _vm.selectedCountry.isoCode2 === "DE" &&
      _vm.addressType === "2"
        ? [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                _vm.isInOptionalFields("de", "delivery_address.salutation")
                  ? _c("div", { staticClass: "col-12 col-sm-4" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.isInRequiredFields(
                                "de",
                                "delivery_address.salutation"
                              ),
                              expression:
                                "\n                            isInRequiredFields(\n                                'de',\n                                'delivery_address.salutation'\n                            )\n                        ",
                            },
                          ],
                          staticClass: "input-unit",
                        },
                        [
                          _c("salutation-select", {
                            attrs: {
                              id: "txtSalutation" + _vm._uid,
                              "address-data": _vm.value,
                              "address-type": _vm.addressType,
                              "enabled-address-fields":
                                _vm.optionalAddressFields,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  $event.field,
                                  $event.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "txtSalutation" + _vm._uid } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.transformTranslation(
                                      "Ceres::Template.addressSalutation",
                                      "de",
                                      "delivery_address.salutation"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                (_vm.isInOptionalFields("de", "delivery_address.salutation") &&
                  _vm.value.gender === "company") ||
                (_vm.isInOptionalFields("de", "delivery_address.name1") &&
                  !_vm.isInOptionalFields("de", "delivery_address.salutation"))
                  ? _c("div", { staticClass: "col-12 col-sm-6" }, [
                      _c(
                        "div",
                        {
                          staticClass: "input-unit",
                          attrs: {
                            "data-model": "name1",
                            "data-validate": "text",
                          },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "txtCompany" + _vm._uid,
                              "data-testing": "packing-station-de-company",
                              inputmode: "text",
                              maxlength: "30",
                              name: "company",
                              type: "text",
                            },
                            domProps: { value: _vm.value.name1 },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  "name1",
                                  $event.target.value
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "txtCompany" + _vm._uid } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.addressCompany"
                                  )
                                ) + "*"
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c(
                "div",
                { staticClass: "row" },
                [
                  _vm.isInOptionalFields("de", "delivery_address.title")
                    ? _c("div", { staticClass: "col-12 col-sm-4" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate:text",
                                value: _vm.isInRequiredFields(
                                  "de",
                                  "delivery_address.title"
                                ),
                                expression:
                                  "\n                            isInRequiredFields(\n                                'de',\n                                'delivery_address.title'\n                            )\n                        ",
                                arg: "text",
                              },
                            ],
                            staticClass: "input-unit",
                            attrs: { "data-model": "title" },
                          },
                          [
                            _c("input", {
                              attrs: {
                                id: "txtTitle" + _vm._uid,
                                inputmode: "email",
                                maxlength: "30",
                                name: "title",
                                type: "text",
                              },
                              domProps: { value: _vm.value.title },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInputEvent(
                                    "title",
                                    $event.target.value
                                  )
                                },
                                keypress: function ($event) {
                                  return _vm.filterCharacters($event)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "txtTitle" + _vm._uid } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.transformTranslation(
                                        "Ceres::Template.addressTitle",
                                        "de",
                                        "delivery_address.title"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.areNameFieldsShown("de", "delivery_address")
                    ? [
                        _c("div", { staticClass: "col-12 col-sm-4" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate:text",
                                  value: _vm.areNameFieldsRequired(
                                    "de",
                                    "delivery_address"
                                  ),
                                  expression:
                                    "\n                                areNameFieldsRequired(\n                                    'de',\n                                    'delivery_address'\n                                )\n                            ",
                                  arg: "text",
                                },
                              ],
                              staticClass: "input-unit",
                              attrs: { "data-model": "name2" },
                            },
                            [
                              _c("input", {
                                attrs: {
                                  id: "txtFirstName" + _vm._uid,
                                  "data-testing":
                                    "packing-station-de-firstname",
                                  inputmode: "text",
                                  maxlength: "19",
                                  name: "firstName",
                                  type: "text",
                                },
                                domProps: { value: _vm.value.name2 },
                                on: {
                                  input: function ($event) {
                                    return _vm.emitInputEvent(
                                      "name2",
                                      $event.target.value
                                    )
                                  },
                                  keypress: function ($event) {
                                    return _vm.filterCharacters($event)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "txtFirstName" + _vm._uid } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.addressFirstName"
                                      )
                                    ) + "\n                                "
                                  ),
                                  _vm.areNameFieldsRequired(
                                    "de",
                                    "delivery_address"
                                  )
                                    ? [_vm._v("*")]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-sm-4" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate:text",
                                  value: _vm.areNameFieldsRequired(
                                    "de",
                                    "delivery_address"
                                  ),
                                  expression:
                                    "\n                                areNameFieldsRequired(\n                                    'de',\n                                    'delivery_address'\n                                )\n                            ",
                                  arg: "text",
                                },
                              ],
                              staticClass: "input-unit",
                              attrs: { "data-model": "name3" },
                            },
                            [
                              _c("input", {
                                attrs: {
                                  id: "txtLastName" + _vm._uid,
                                  "data-testing": "packing-station-de-lastname",
                                  maxlength: "19",
                                  name: "lastName",
                                  type: "text",
                                },
                                domProps: { value: _vm.value.name3 },
                                on: {
                                  input: function ($event) {
                                    return _vm.emitInputEvent(
                                      "name3",
                                      $event.target.value
                                    )
                                  },
                                  keypress: function ($event) {
                                    return _vm.filterCharacters($event)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "txtLastName" + _vm._uid } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.addressLastName"
                                      )
                                    ) + "\n                                "
                                  ),
                                  _vm.areNameFieldsRequired(
                                    "de",
                                    "delivery_address"
                                  )
                                    ? [_vm._v("*")]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          ),
                        ]),
                      ]
                    : _c("div", { staticClass: "col-12 col-sm-8" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate:text",
                                value: _vm.isInRequiredFields(
                                  "de",
                                  "delivery_address.contactPerson"
                                ),
                                expression:
                                  "\n                            isInRequiredFields(\n                                'de',\n                                'delivery_address.contactPerson'\n                            )\n                        ",
                                arg: "text",
                              },
                            ],
                            staticClass: "input-unit",
                            attrs: { "data-model": "contactPerson" },
                          },
                          [
                            _c("input", {
                              attrs: {
                                id: "txtContactPerson" + _vm._uid,
                                inputmode: "text",
                                maxlength: "19",
                                name: "lastName",
                                type: "text",
                              },
                              domProps: { value: _vm.value.contactPerson },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInputEvent(
                                    "contactPerson",
                                    $event.target.value
                                  )
                                },
                                keypress: function ($event) {
                                  return _vm.filterCharacters($event)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "txtContactPerson" + _vm._uid } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.transformTranslation(
                                        "Ceres::Template.addressContactPerson",
                                        "de",
                                        "delivery_address.contactPerson"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                  _vm._v(" "),
                  _vm.isInOptionalFields("de", "delivery_address.name4")
                    ? _c("div", { staticClass: "col-12 col-sm-4" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate:text",
                                value: _vm.isInRequiredFields(
                                  "de",
                                  "delivery_address.name4"
                                ),
                                expression:
                                  "\n                            isInRequiredFields(\n                                'de',\n                                'delivery_address.name4'\n                            )\n                        ",
                                arg: "text",
                              },
                            ],
                            staticClass: "input-unit",
                            attrs: { "data-model": "name4" },
                          },
                          [
                            _c("input", {
                              attrs: {
                                id: "txtAdditionalName" + _vm._uid,
                                inputmode: "text",
                                maxlength: "30",
                                name: "decorateName",
                                type: "text",
                              },
                              domProps: { value: _vm.value.name4 },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInputEvent(
                                    "name4",
                                    $event.target.value
                                  )
                                },
                                keypress: function ($event) {
                                  return _vm.filterCharacters($event)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                attrs: { for: "txtAdditionalName" + _vm._uid },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.transformTranslation(
                                        "Ceres::Template.addressAdditionalName",
                                        "de",
                                        "delivery_address.name4"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isInOptionalFields("de", "delivery_address.phoneNumber")
                    ? _c("div", { staticClass: "col-12 col-sm-4" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate:text",
                                value: _vm.isInRequiredFields(
                                  "de",
                                  "delivery_address.phoneNumber"
                                ),
                                expression:
                                  "\n                            isInRequiredFields(\n                                'de',\n                                'delivery_address.phoneNumber'\n                            )\n                        ",
                                arg: "text",
                              },
                            ],
                            staticClass: "input-unit",
                            attrs: { "data-model": "telephone" },
                          },
                          [
                            _c("input", {
                              attrs: {
                                id: "txtTelephone" + _vm._uid,
                                inputmode: "tel",
                                maxlength: "30",
                                name: "telephone",
                                type: "tel",
                              },
                              domProps: { value: _vm.value.telephone },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInputEvent(
                                    "telephone",
                                    $event.target.value
                                  )
                                },
                                keypress: function ($event) {
                                  return _vm.onlyNumbers(
                                    "telephone",
                                    _vm._uid,
                                    $event
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "txtTelephone" + _vm._uid } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.transformTranslation(
                                        "Ceres::Template.addressTelephone",
                                        "de",
                                        "delivery_address.phoneNumber"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _vm.isParcelOrOfficeAvailable
              ? _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("input", {
                        attrs: {
                          id: "showPickup" + _vm._uid,
                          name: "togglePickup",
                          type: "checkbox",
                        },
                        domProps: { checked: _vm.value.showPickupStation },
                        on: {
                          change: function ($event) {
                            return _vm.togglePickupStation(
                              $event.target.checked
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "showPickup" + _vm._uid } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$translate(
                              "Ceres::Template.addressToPickupStation"
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-sm-8" }, [
                  _c(
                    "div",
                    {
                      staticClass: "input-unit",
                      attrs: { "data-model": "address1", "data-validate": "" },
                    },
                    [
                      _c(
                        "select",
                        {
                          staticClass: "custom-select",
                          attrs: { id: "address1" + _vm._uid },
                          domProps: { value: _vm.value.address1 },
                          on: {
                            change: function ($event) {
                              return _vm.emitInputEvent(
                                "address1",
                                $event.target.value
                              )
                            },
                          },
                        },
                        [
                          _vm.isParcelBoxAvailable
                            ? _c(
                                "option",
                                {
                                  attrs: { value: "PACKSTATION" },
                                  domProps: { selected: _vm.isPickupStation },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.addressPackingStation"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isPostOfficeAvailable
                            ? _c(
                                "option",
                                {
                                  attrs: { value: "POSTFILIALE" },
                                  domProps: { selected: _vm.isPostOffice },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.addressPostOffice"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "'address1' + _uid" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$translate(
                              "Ceres::Template.addressPickupLocation"
                            )
                          )
                        ),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-sm-4" }, [
                  _c(
                    "div",
                    {
                      staticClass: "input-unit",
                      attrs: {
                        "data-model": "address2",
                        "data-validate": "text",
                      },
                    },
                    [
                      _c("input", {
                        attrs: {
                          id: "txtNumber" + _vm._uid,
                          autocomplete: "address-line2",
                          inputmode: "text",
                          maxlength: "30",
                          name: "housenumber",
                          type: "text",
                        },
                        domProps: { value: _vm.value.address2 },
                        on: {
                          input: function ($event) {
                            return _vm.emitInputEvent(
                              "address2",
                              $event.target.value
                            )
                          },
                          keypress: function ($event) {
                            return _vm.filterCharacters($event)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.isPickupStation
                        ? _c(
                            "label",
                            { attrs: { for: "txtNumber" + _vm._uid } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.addressPackingStationNumber"
                                  )
                                ) + "*"
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isPostOffice
                        ? _c(
                            "label",
                            { attrs: { for: "txtNumber" + _vm._uid } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.addressPostOfficeNumber"
                                  )
                                ) + "*"
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-sm-6" }, [
                  _c(
                    "div",
                    {
                      staticClass: "input-unit",
                      attrs: {
                        "data-model": "postNumber",
                        "data-validate": "text",
                      },
                    },
                    [
                      _c("input", {
                        attrs: {
                          id: "postnumber" + _vm._uid,
                          "data-testing": "packing-station-de-postnumber",
                          inputmode: "text",
                          maxlength: "30",
                          name: "postnumber",
                          type: "text",
                        },
                        domProps: { value: _vm.value.postNumber },
                        on: {
                          input: function ($event) {
                            return _vm.emitInputEvent(
                              "postNumber",
                              $event.target.value
                            )
                          },
                          keypress: function ($event) {
                            return _vm.filterCharacters($event)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "postnumber" + _vm._uid } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("Ceres::Template.addressPostNummer")
                          ) + "*"
                        ),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _vm.isInOptionalFields("de", "delivery_address.address4")
                  ? _c("div", { staticClass: "col-12 col-sm-6" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate:text",
                              value: _vm.isInRequiredFields(
                                "de",
                                "delivery_address.address4"
                              ),
                              expression:
                                "\n                            isInRequiredFields(\n                                'de',\n                                'delivery_address.address4'\n                            )\n                        ",
                              arg: "text",
                            },
                          ],
                          staticClass: "input-unit",
                          attrs: { "data-model": "address4" },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "decorateAddress1" + _vm._uid,
                              inputmode: "text",
                              maxlength: "30",
                              name: "decorateAddress",
                              type: "text",
                            },
                            domProps: { value: _vm.value.address4 },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  "address4",
                                  $event.target.value
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "decorateAddress1" + _vm._uid } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.transformTranslation(
                                      "Ceres::Template.addressAdditionalAddress2",
                                      "de",
                                      "delivery_address.address4"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-sm-4" }, [
              _c(
                "div",
                {
                  staticClass: "input-unit",
                  attrs: {
                    "data-model": "postalCode",
                    "data-validate": "postalCode",
                  },
                },
                [
                  _c("input", {
                    attrs: {
                      id: "txtZip" + _vm._uid,
                      "data-testing": "packing-station-de-postalcode",
                      inputmode: "numeric",
                      maxlength: "4",
                      name: "zip",
                      type: "text",
                      minlength: "4",
                    },
                    domProps: { value: _vm.value.postalCode },
                    on: {
                      input: function ($event) {
                        return _vm.emitInputEvent(
                          "postalCode",
                          $event.target.value
                        )
                      },
                      keypress: function ($event) {
                        return _vm.onlyNumbers("postalCode", _vm._uid, $event)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "txtZip" + _vm._uid } }, [
                    _vm._v(
                      _vm._s(_vm.$translate("Ceres::Template.addressZip")) + "*"
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "errTxtZip" + _vm._uid,
                      staticClass:
                        "errmsg text-danger position-absolute small mt-1",
                      staticStyle: { display: "none" },
                      attrs: { id: "errTxtZip" + _vm._uid },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate(
                              "GonserDT::Template.checkoutOnlyNumbers"
                            )
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-sm-4" }, [
              _c(
                "div",
                {
                  staticClass: "input-unit",
                  attrs: { "data-model": "town", "data-validate": "text" },
                },
                [
                  _c("input", {
                    attrs: {
                      id: "txtPlace" + _vm._uid,
                      "data-testing": "packing-station-de-town",
                      inputmode: "text",
                      maxlength: "30",
                      name: "town",
                      type: "text",
                    },
                    domProps: { value: _vm.value.town },
                    on: {
                      input: function ($event) {
                        return _vm.emitInputEvent("town", $event.target.value)
                      },
                      keypress: function ($event) {
                        return _vm.filterCharacters($event)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "txtPlace" + _vm._uid } }, [
                    _vm._v(
                      _vm._s(_vm.$translate("Ceres::Template.addressPlace")) +
                        "*"
                    ),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-12 col-sm-4",
                attrs: { "data-testing": "address-country-select" },
              },
              [
                _c("country-select", {
                  attrs: {
                    "address-type": _vm.addressType,
                    "optional-address-fields": _vm.optionalAddressFields,
                    "required-address-fields": _vm.requiredAddressFields,
                    specificCountryIds: [4, 34],
                    "selected-country-id": _vm.value.countryId,
                    "selected-state-id": _vm.value.stateId,
                  },
                  on: {
                    "country-changed": function ($event) {
                      return _vm.onSelectedCountryChanged($event)
                    },
                    "state-changed": function ($event) {
                      return _vm.emitInputEvent("stateId", $event)
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm._t("custom-address-fields"),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c("hr", { staticClass: "mt-0" }),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _vm.isInOptionalFields("de", "delivery_address.email")
                  ? _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate:text",
                              value: _vm.isInRequiredFields(
                                "de",
                                "delivery_address.email"
                              ),
                              expression:
                                "\n                            isInRequiredFields(\n                                'de',\n                                'delivery_address.email'\n                            )\n                        ",
                              arg: "text",
                            },
                          ],
                          staticClass: "input-unit",
                          attrs: { "data-model": "email" },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "email" + _vm._uid,
                              "data-testing": "packing-station-de-email-input",
                              inputmode: "email",
                              maxlength: "30",
                              name: "email",
                              type: "mail",
                            },
                            domProps: { value: _vm.value.email },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  "email",
                                  $event.target.value
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "email" + _vm._uid } }, [
                            _vm._v(
                              _vm._s(
                                _vm.transformTranslation(
                                  "Ceres::Template.addressMail",
                                  "de",
                                  "delivery_address.email"
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]
        : _vm.localeToShow == "DE" && _vm.addressType === "1" && _vm.isMobile
        ? [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                _vm.isInOptionalFields("de", "billing_address.salutation")
                  ? _c("div", { staticClass: "col-12 col-sm-4" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.isInRequiredFields(
                                "de",
                                "billing_address.salutation"
                              ),
                              expression:
                                "\n                            isInRequiredFields(\n                                'de',\n                                'billing_address.salutation'\n                            )\n                        ",
                            },
                          ],
                          staticClass: "input-unit",
                        },
                        [
                          _c("salutation-select", {
                            attrs: {
                              id: "txtSalutation" + _vm._uid,
                              "address-data": _vm.value,
                              "address-type": _vm.addressType,
                              "default-salutation": _vm.defaultSalutation,
                              "enabled-address-fields":
                                _vm.optionalAddressFields,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  $event.field,
                                  $event.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "txtSalutation" + _vm._uid } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.transformTranslation(
                                      "Ceres::Template.addressSalutation",
                                      "de",
                                      "billing_address.salutation"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                (_vm.isInOptionalFields("de", "billing_address.salutation") &&
                  _vm.value.gender === "company") ||
                (_vm.isInOptionalFields("de", "billing_address.name1") &&
                  !_vm.isInOptionalFields("de", "billing_address.salutation"))
                  ? _c("div", { staticClass: "col-12 col-sm-6" }, [
                      _c(
                        "div",
                        {
                          staticClass: "input-unit",
                          class: {
                            "error-without-z": _vm.isCompanyValid1 === false,
                            "success-without-z": _vm.isCompanyValid1 === true,
                          },
                          attrs: {
                            "data-model": "name1",
                            "data-validate": "text",
                          },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "txtCompany" + _vm._uid,
                              "data-autofocus": "",
                              "data-testing": "billing-address-de-company",
                              inputmode: "text",
                              maxlength: "30",
                              name: "company",
                              type: "text",
                            },
                            domProps: { value: _vm.value.name1 },
                            on: {
                              input: function ($event) {
                                _vm.emitInputEvent("name1", $event.target.value)
                                _vm.clearTimer("C1")
                                _vm.setTimer("C1", function () {
                                  _vm.isAddressEmpty(
                                    $event.target.value,
                                    "company",
                                    1
                                  )
                                })
                              },
                              blur: function ($event) {
                                _vm.clearTimer("C1")
                                _vm.isAddressEmpty(
                                  $event.target.value,
                                  "company",
                                  1
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "txtCompany" + _vm._uid } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.addressCompany"
                                  )
                                ) + "*"
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-sm-6" },
                  [
                    _c("vat-id", {
                      attrs: {
                        "is-required": _vm.isInRequiredFields(
                          "de",
                          "billing_address.vatNumber"
                        ),
                        "selected-country-id": _vm.value.countryId,
                        "show-input":
                          (_vm.isInOptionalFields(
                            "de",
                            "billing_address.salutation"
                          ) &&
                            _vm.value.gender === "company" &&
                            _vm.isInOptionalFields(
                              "de",
                              "billing_address.vatNumber"
                            )) ||
                          (!_vm.isInOptionalFields(
                            "de",
                            "billing_address.salutation"
                          ) &&
                            _vm.isInOptionalFields(
                              "de",
                              "billing_address.name1"
                            ) &&
                            _vm.isInOptionalFields(
                              "de",
                              "billing_address.vatNumber"
                            )),
                        value: _vm.value.vatNumber || "",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.emitInputEvent("vatNumber", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-12",
                attrs: { "data-testing": "billing-address-de-name-inputs" },
              },
              [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _vm.isInOptionalFields("de", "billing_address.title")
                      ? _c("div", { staticClass: "col-12 col-sm-4" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate:text",
                                  value: _vm.isInRequiredFields(
                                    "de",
                                    "billing_address.title"
                                  ),
                                  expression:
                                    "\n                            isInRequiredFields(\n                                'de',\n                                'billing_address.title'\n                            )\n                        ",
                                  arg: "text",
                                },
                              ],
                              staticClass: "input-unit",
                              attrs: { "data-model": "title" },
                            },
                            [
                              _c("input", {
                                attrs: {
                                  id: "txtTitle" + _vm._uid,
                                  "data-autofocus": "",
                                  "data-testing": "billing-address-de-title",
                                  inputmode: "text",
                                  maxlength: "30",
                                  name: "title",
                                  type: "text",
                                },
                                domProps: { value: _vm.value.title },
                                on: {
                                  input: function ($event) {
                                    return _vm.emitInputEvent(
                                      "title",
                                      $event.target.value
                                    )
                                  },
                                  keypress: function ($event) {
                                    return _vm.filterCharacters($event)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "txtTitle" + _vm._uid } },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.transformTranslation(
                                          "Ceres::Template.addressTitle",
                                          "de",
                                          "billing_address.title"
                                        )
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.areNameFieldsShown("de", "billing_address")
                      ? [
                          _c("div", { staticClass: "col-12 col-sm-4" }, [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate:text",
                                    value: _vm.areNameFieldsRequired(
                                      "de",
                                      "billing_address"
                                    ),
                                    expression:
                                      "\n                                areNameFieldsRequired(\n                                    'de',\n                                    'billing_address'\n                                )\n                            ",
                                    arg: "text",
                                  },
                                ],
                                staticClass: "input-unit",
                                class: {
                                  "error-without-z":
                                    _vm.isFirstNameValid1 === false,
                                  "success-without-z":
                                    _vm.isFirstNameValid1 === true,
                                },
                                attrs: { "data-model": "name2" },
                              },
                              [
                                _c("input", {
                                  attrs: {
                                    id: "txtFirstName" + _vm._uid,
                                    "data-autofocus": "",
                                    "data-testing":
                                      "billing-address-de-firstname",
                                    inputmode: "text",
                                    maxlength: "19",
                                    name: "firstName",
                                    type: "text",
                                  },
                                  domProps: { value: _vm.value.name2 },
                                  on: {
                                    input: function ($event) {
                                      var inputValue = $event.target.value
                                      _vm.emitInputEvent(
                                        "name2",
                                        $event.target.value
                                      )
                                      _vm.clearTimer("FN1")
                                      _vm.setTimer("FN1", function () {
                                        _vm.isAddressEmpty(
                                          inputValue,
                                          "firstName",
                                          1
                                        )
                                      })
                                    },
                                    blur: function ($event) {
                                      _vm.clearTimer("FN1")
                                      _vm.isAddressEmpty(
                                        $event.target.value,
                                        "firstName",
                                        1
                                      )
                                    },
                                    keypress: function ($event) {
                                      return _vm.filterCharacters($event)
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "txtFirstName" + _vm._uid } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.addressFirstName"
                                        )
                                      ) + "\n                                "
                                    ),
                                    _vm.areNameFieldsRequired(
                                      "de",
                                      "billing_address"
                                    )
                                      ? [_vm._v("*")]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-4" }, [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate:text",
                                    value: _vm.areNameFieldsRequired(
                                      "de",
                                      "billing_address"
                                    ),
                                    expression:
                                      "\n                                areNameFieldsRequired(\n                                    'de',\n                                    'billing_address'\n                                )\n                            ",
                                    arg: "text",
                                  },
                                ],
                                staticClass: "input-unit",
                                class: {
                                  "error-without-z":
                                    _vm.isLastNameValid1 === false,
                                  "success-without-z":
                                    _vm.isLastNameValid1 === true,
                                },
                                attrs: { "data-model": "name3" },
                              },
                              [
                                _c("input", {
                                  attrs: {
                                    id: "txtLastName" + _vm._uid,
                                    "data-testing":
                                      "billing-address-de-lastname",
                                    inputmode: "text",
                                    maxlength: "19",
                                    name: "lastName",
                                    type: "text",
                                  },
                                  domProps: { value: _vm.value.name3 },
                                  on: {
                                    input: function ($event) {
                                      var inputValue = $event.target.value
                                      _vm.emitInputEvent(
                                        "name3",
                                        $event.target.value
                                      )
                                      _vm.clearTimer("LN1")
                                      _vm.setTimer("LN1", function () {
                                        _vm.isAddressEmpty(
                                          inputValue,
                                          "lastName",
                                          1
                                        )
                                      })
                                    },
                                    blur: function ($event) {
                                      _vm.clearTimer("LN1")
                                      _vm.isAddressEmpty(
                                        $event.target.value,
                                        "lastName",
                                        1
                                      )
                                    },
                                    keypress: function ($event) {
                                      return _vm.filterCharacters($event)
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "txtLastName" + _vm._uid } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.addressLastName"
                                        )
                                      ) + "\n                                "
                                    ),
                                    _vm.areNameFieldsRequired(
                                      "de",
                                      "billing_address"
                                    )
                                      ? [_vm._v("*")]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ]),
                        ]
                      : _c("div", { staticClass: "col-12 col-sm-8" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate:text",
                                  value: _vm.isInRequiredFields(
                                    "de",
                                    "billing_address.contactPerson"
                                  ),
                                  expression:
                                    "\n                            isInRequiredFields(\n                                'de',\n                                'billing_address.contactPerson'\n                            )\n                        ",
                                  arg: "text",
                                },
                              ],
                              staticClass: "input-unit",
                              attrs: { "data-model": "contactPerson" },
                            },
                            [
                              _c("input", {
                                attrs: {
                                  id: "txtContactPerson" + _vm._uid,
                                  inputmode: "text",
                                  maxlength: "19",
                                  name: "lastName",
                                  type: "text",
                                },
                                domProps: { value: _vm.value.contactPerson },
                                on: {
                                  input: function ($event) {
                                    return _vm.emitInputEvent(
                                      "contactPerson",
                                      $event.target.value
                                    )
                                  },
                                  keypress: function ($event) {
                                    return _vm.filterCharacters($event)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  attrs: { for: "txtContactPerson" + _vm._uid },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.transformTranslation(
                                          "Ceres::Template.addressContactPerson",
                                          "de",
                                          "billing_address.contactPerson"
                                        )
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                    _vm._v(" "),
                    _vm.isInOptionalFields("de", "billing_address.name4")
                      ? _c("div", { staticClass: "col-12 col-sm-4" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate:text",
                                  value: _vm.isInRequiredFields(
                                    "de",
                                    "billing_address.name4"
                                  ),
                                  expression:
                                    "\n                            isInRequiredFields(\n                                'de',\n                                'billing_address.name4'\n                            )\n                        ",
                                  arg: "text",
                                },
                              ],
                              staticClass: "input-unit",
                              attrs: { "data-model": "name4" },
                            },
                            [
                              _c("input", {
                                attrs: {
                                  id: "txtAdditionalName" + _vm._uid,
                                  inputmode: "text",
                                  maxlength: "30",
                                  name: "decorateName",
                                  type: "text",
                                },
                                domProps: { value: _vm.value.name4 },
                                on: {
                                  input: function ($event) {
                                    return _vm.emitInputEvent(
                                      "name4",
                                      $event.target.value
                                    )
                                  },
                                  keypress: function ($event) {
                                    return _vm.filterCharacters($event)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  attrs: {
                                    for: "txtAdditionalName" + _vm._uid,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.transformTranslation(
                                          "Ceres::Template.addressAdditionalName",
                                          "de",
                                          "billing_address.name4"
                                        )
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isInOptionalFields("de", "billing_address.birthday")
                      ? _c("div", { staticClass: "col-12 col-sm-4" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate:date",
                                  value:
                                    _vm.isInRequiredFields(
                                      "de",
                                      "billing_address.birthday"
                                    ) ||
                                    (!!_vm.value.birthday &&
                                      !!_vm.value.birthday.length),
                                  expression:
                                    "\n                            isInRequiredFields(\n                                'de',\n                                'billing_address.birthday'\n                            ) ||\n                            (!!value.birthday && !!value.birthday.length)\n                        ",
                                  arg: "date",
                                },
                              ],
                              staticClass: "input-unit",
                              attrs: { "data-model": "birthday" },
                            },
                            [
                              _c("input", {
                                attrs: {
                                  id: "txtBirthdate" + _vm._uid,
                                  max: new Date().toISOString().split("T")[0],
                                  placeholder: _vm.$translate(
                                    "Ceres::Template.addressBirthdatePlaceholder"
                                  ),
                                  min: "1901-12-14",
                                  name: "birthday",
                                  type: "date",
                                },
                                domProps: { value: _vm.value.birthday },
                                on: {
                                  input: function ($event) {
                                    return _vm.emitInputEvent(
                                      "birthday",
                                      $event.target.value
                                    )
                                  },
                                  keypress: function ($event) {
                                    return _vm.filterCharacters($event)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "txtBirthdate" + _vm._uid } },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.transformTranslation(
                                          "Ceres::Template.addressBirthdate",
                                          "de",
                                          "billing_address.birthday"
                                        )
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isInOptionalFields("de", "billing_address.phoneNumber")
                      ? _c("div", { staticClass: "col-12 col-sm-4" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate:text",
                                  value: _vm.isInRequiredFields(
                                    "de",
                                    "billing_address.phoneNumber"
                                  ),
                                  expression:
                                    "\n                            isInRequiredFields(\n                                'de',\n                                'billing_address.phoneNumber'\n                            )\n                        ",
                                  arg: "text",
                                },
                              ],
                              staticClass: "input-unit",
                              attrs: { "data-model": "telephone" },
                            },
                            [
                              _c("input", {
                                attrs: {
                                  id: "txtTelephone" + _vm._uid,
                                  inputmode: "tel",
                                  maxlength: "30",
                                  name: "telephone",
                                  type: "tel",
                                },
                                domProps: { value: _vm.value.telephone },
                                on: {
                                  input: function ($event) {
                                    return _vm.emitInputEvent(
                                      "telephone",
                                      $event.target.value
                                    )
                                  },
                                  keypress: function ($event) {
                                    return _vm.filterCharacters($event)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "txtTelephone" + _vm._uid } },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.transformTranslation(
                                          "Ceres::Template.addressTelephone",
                                          "de",
                                          "billing_address.phoneNumber"
                                        )
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-12",
                attrs: { "data-testing": "billing-address-de-street-inputs" },
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 col-sm-8" }, [
                    _c(
                      "div",
                      {
                        staticClass: "input-unit",
                        class: {
                          "error-without-z": _vm.isStreetNameValid1 === false,
                          "success-without-z": _vm.isStreetNameValid1 === true,
                        },
                        attrs: {
                          "data-model": "address1",
                          "data-validate": "text",
                        },
                      },
                      [
                        _c("input", {
                          attrs: {
                            id: "txtStreet" + _vm._uid,
                            autocomplete: "address-line1",
                            "data-testing": "billing-address-de-street",
                            inputmode: "text",
                            maxlength: "30",
                            name: "street",
                            type: "text",
                          },
                          domProps: { value: _vm.value.address1 },
                          on: {
                            input: function ($event) {
                              var inputValue = $event.target.value
                              _vm.emitInputEvent(
                                "address1",
                                $event.target.value
                              )
                              _vm.clearTimer("SN1")
                              _vm.setTimer("SN1", function () {
                                _vm.isAddressEmpty(inputValue, "street", 1)
                              })
                            },
                            blur: function ($event) {
                              _vm.clearTimer("SN1")
                              _vm.isAddressEmpty(
                                $event.target.value,
                                "street",
                                1
                              )
                            },
                            keypress: function ($event) {
                              return _vm.filterCharacters($event)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          { attrs: { for: "txtStreet" + _vm._uid } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$translate("Ceres::Template.addressStreet")
                              ) + "*"
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-sm-4" }, [
                    _c(
                      "div",
                      {
                        staticClass: "input-unit",
                        class: {
                          "error-without-z": _vm.isHouseNumberValid1 === false,
                          "success-without-z": _vm.isHouseNumberValid1 === true,
                        },
                        attrs: {
                          "data-model": "address2",
                          "data-validate": "text",
                        },
                      },
                      [
                        _c("input", {
                          attrs: {
                            id: "txtNumber" + _vm._uid,
                            autocomplete: "address-line2",
                            "data-testing": "billing-address-de-house-number",
                            inputmode: "text",
                            maxlength: "30",
                            name: "housenumber",
                            type: "text",
                          },
                          domProps: { value: _vm.value.address2 },
                          on: {
                            input: function ($event) {
                              var inputValue = $event.target.value
                              _vm.emitInputEvent(
                                "address2",
                                $event.target.value
                              )
                              _vm.clearTimer("HN1")
                              _vm.setTimer("HN1", function () {
                                _vm.isAddressEmpty(inputValue, "houseNumber", 1)
                              })
                            },
                            blur: function ($event) {
                              _vm.clearTimer("HN1")
                              _vm.isAddressEmpty(
                                $event.target.value,
                                "houseNumber",
                                1
                              )
                            },
                            keypress: function ($event) {
                              return _vm.filterCharacters($event)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          { attrs: { for: "txtNumber" + _vm._uid } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$translate("Ceres::Template.addressNumber")
                              ) + "*"
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                _vm.isInOptionalFields("de", "billing_address.address3")
                  ? _c("div", { staticClass: "col-12 col-sm-6" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate:text",
                              value: _vm.isInRequiredFields(
                                "de",
                                "billing_address.address3"
                              ),
                              expression:
                                "\n                            isInRequiredFields(\n                                'de',\n                                'billing_address.address3'\n                            )\n                        ",
                              arg: "text",
                            },
                          ],
                          staticClass: "input-unit",
                          attrs: { "data-model": "address3" },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "decorateAddress0" + _vm._uid,
                              inputmode: "text",
                              maxlength: "30",
                              name: "decorateAddress",
                              type: "text",
                            },
                            domProps: { value: _vm.value.address3 },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  "address3",
                                  $event.target.value
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "decorateAddress0" + _vm._uid } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.transformTranslation(
                                      "Ceres::Template.addressAdditionalAddress1",
                                      "de",
                                      "billing_address.address3"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isInOptionalFields("de", "billing_address.address4")
                  ? _c("div", { staticClass: "col-12 col-sm-6" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate:text",
                              value: _vm.isInRequiredFields(
                                "de",
                                "billing_address.address4"
                              ),
                              expression:
                                "\n                            isInRequiredFields(\n                                'de',\n                                'billing_address.address4'\n                            )\n                        ",
                              arg: "text",
                            },
                          ],
                          staticClass: "input-unit",
                          attrs: { "data-model": "address4" },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "decorateAddress1" + _vm._uid,
                              inputmode: "text",
                              maxlength: "30",
                              name: "decorateAddress",
                              type: "text",
                            },
                            domProps: { value: _vm.value.address4 },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  "address4",
                                  $event.target.value
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "decorateAddress1" + _vm._uid } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.transformTranslation(
                                      "Ceres::Template.addressAdditionalAddress2",
                                      "de",
                                      "billing_address.address4"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-sm-4" }, [
              _c(
                "div",
                {
                  staticClass: "input-unit",
                  class: {
                    "error-without-z": _vm.isPostalCodeValid1 === false,
                    "success-without-z": _vm.isPostalCodeValid1 === true,
                  },
                  attrs: {
                    "data-model": "postalCode",
                    "data-validate": "postalCode",
                  },
                },
                [
                  _c("input", {
                    staticClass: "postalCodeCustom",
                    attrs: {
                      id: "txtZip" + _vm._uid,
                      "data-testing": "billing-address-de-zip",
                      inputmode: "numeric",
                      maxlength: "4",
                      name: "zip",
                      type: "text",
                      pattern: ".{4,4}",
                    },
                    domProps: { value: _vm.value.postalCode },
                    on: {
                      input: function ($event) {
                        var inputValue = $event.target.value
                        _vm.emitInputEvent("postalCode", $event.target.value)
                        _vm.clearTimer("ZIP1")
                        _vm.setTimer("ZIP1", function () {
                          _vm.validatePostalCode(inputValue, 1)
                        })
                      },
                      blur: function ($event) {
                        _vm.clearTimer("ZIP1")
                        _vm.validatePostalCode($event.target.value, 1)
                      },
                      keypress: function ($event) {
                        return _vm.onlyNumbers("postalCode", _vm._uid, $event)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "txtZip" + _vm._uid } }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$translate("Ceres::Template.addressZip")) +
                        "*\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "errTxtZip" + _vm._uid,
                      staticClass:
                        "errmsg text-danger position-absolute small mt-1",
                      staticStyle: { display: "none" },
                      attrs: { id: "errTxtZip" + _vm._uid },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate(
                              "GonserDT::Template.checkoutOnlyNumbers"
                            )
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "errTxtZipLength bg-warning p-3" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$translate("GonserDT::Template.checkoutZipLength")
                        ) +
                        "\n                "
                    ),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-sm-4" }, [
              _c(
                "div",
                {
                  staticClass: "input-unit",
                  class: {
                    "error-without-z": _vm.isTownValid1 === false,
                    "success-without-z": _vm.isTownValid1 === true,
                  },
                  attrs: { "data-model": "town", "data-validate": "text" },
                },
                [
                  _c("input", {
                    attrs: {
                      id: "txtPlace" + _vm._uid,
                      "data-testing": "billing-address-de-town",
                      inputmode: "text",
                      maxlength: "30",
                      name: "town",
                      type: "text",
                    },
                    domProps: { value: _vm.value.town },
                    on: {
                      input: function ($event) {
                        var inputValue = $event.target.value
                        _vm.emitInputEvent("town", $event.target.value)
                        _vm.clearTimer("T1")
                        _vm.setTimer("T1", function () {
                          _vm.isAddressEmpty(inputValue, "town", 1)
                        })
                      },
                      blur: function ($event) {
                        _vm.clearTimer("T1")
                        _vm.isAddressEmpty($event.target.value, "town", 1)
                      },
                      keypress: function ($event) {
                        return _vm.filterCharacters($event)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "txtPlace" + _vm._uid } }, [
                    _vm._v(
                      _vm._s(_vm.$translate("Ceres::Template.addressPlace")) +
                        "*"
                    ),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-12 col-sm-4",
                attrs: { "data-testing": "address-country-select" },
              },
              [
                _c("country-select", {
                  attrs: {
                    "address-type": _vm.addressType,
                    "optional-address-fields": _vm.optionalAddressFields,
                    "required-address-fields": _vm.requiredAddressFields,
                    specificCountryIds: [4, 34],
                    "selected-country-id": _vm.value.countryId,
                    "selected-state-id": _vm.value.stateId,
                  },
                  on: {
                    "country-changed": function ($event) {
                      return _vm.onSelectedCountryChanged($event)
                    },
                    "state-changed": function ($event) {
                      return _vm.emitInputEvent("stateId", $event)
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm._t("custom-address-fields"),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c("hr", { staticClass: "mt-0" }),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _vm.isInOptionalFields("de", "billing_address.email")
                  ? _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate:text",
                              value: _vm.isInRequiredFields(
                                "de",
                                "billing_address.email"
                              ),
                              expression:
                                "\n                            isInRequiredFields(\n                                'de',\n                                'billing_address.email'\n                            )\n                        ",
                              arg: "text",
                            },
                          ],
                          staticClass: "input-unit",
                          attrs: { "data-model": "email" },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "email" + _vm._uid,
                              "data-testing": "billing-address-de-email-input",
                              inputmode: "email",
                              maxlength: "30",
                              name: "email",
                              type: "mail",
                            },
                            domProps: { value: _vm.value.email },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  "email",
                                  $event.target.value
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "email" + _vm._uid } }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.transformTranslation(
                                    "Ceres::Template.addressMail",
                                    "de",
                                    "billing_address.email"
                                  )
                                ) +
                                "\n                        "
                            ),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]
        : _vm.localeToShow == "DE" && _vm.addressType === "1" && !_vm.isMobile
        ? [
            _c("div", { staticClass: "col-12" }, [
              _c(
                "div",
                { staticClass: "row" },
                [
                  _vm.isInOptionalFields("de", "billing_address.salutation")
                    ? _c("div", { staticClass: "col-12 col-sm-4" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: _vm.isInRequiredFields(
                                  "de",
                                  "billing_address.salutation"
                                ),
                                expression:
                                  "\n                            isInRequiredFields(\n                                'de',\n                                'billing_address.salutation'\n                            )\n                        ",
                              },
                            ],
                            staticClass: "input-unit",
                          },
                          [
                            _c("salutation-select", {
                              attrs: {
                                id: "txtSalutation" + _vm._uid,
                                "address-data": _vm.value,
                                "address-type": _vm.addressType,
                                "default-salutation": _vm.defaultSalutation,
                                "enabled-address-fields":
                                  _vm.optionalAddressFields,
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInputEvent(
                                    $event.field,
                                    $event.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "txtSalutation" + _vm._uid } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.transformTranslation(
                                        "Ceres::Template.addressSalutation",
                                        "de",
                                        "billing_address.salutation"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isInOptionalFields("de", "billing_address.title")
                    ? _c("div", { staticClass: "col-12 col-sm-4" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate:text",
                                value: _vm.isInRequiredFields(
                                  "de",
                                  "billing_address.title"
                                ),
                                expression:
                                  "\n                            isInRequiredFields(\n                                'de',\n                                'billing_address.title'\n                            )\n                        ",
                                arg: "text",
                              },
                            ],
                            staticClass: "input-unit",
                            attrs: { "data-model": "title" },
                          },
                          [
                            _c("input", {
                              attrs: {
                                id: "txtTitle" + _vm._uid,
                                "data-autofocus": "",
                                "data-testing": "billing-address-de-title",
                                inputmode: "text",
                                maxlength: "30",
                                name: "title",
                                type: "text",
                              },
                              domProps: { value: _vm.value.title },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInputEvent(
                                    "title",
                                    $event.target.value
                                  )
                                },
                                keypress: function ($event) {
                                  return _vm.filterCharacters($event)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "txtTitle" + _vm._uid } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.transformTranslation(
                                        "Ceres::Template.addressTitle",
                                        "de",
                                        "billing_address.title"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.areNameFieldsShown("de", "billing_address")
                    ? [
                        _c("div", { staticClass: "col-12 col-sm-4" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate:text",
                                  value: _vm.areNameFieldsRequired(
                                    "de",
                                    "billing_address"
                                  ),
                                  expression:
                                    "\n                                areNameFieldsRequired(\n                                    'de',\n                                    'billing_address'\n                                )\n                            ",
                                  arg: "text",
                                },
                              ],
                              staticClass: "input-unit",
                              class: {
                                "error-without-z":
                                  _vm.isFirstNameValid1 === false,
                                "success-without-z":
                                  _vm.isFirstNameValid1 === true,
                              },
                              attrs: { "data-model": "name2" },
                            },
                            [
                              _c("input", {
                                attrs: {
                                  id: "txtFirstName" + _vm._uid,
                                  "data-autofocus": "",
                                  "data-testing":
                                    "billing-address-de-firstname",
                                  inputmode: "text",
                                  maxlength: "19",
                                  name: "firstName",
                                  type: "text",
                                },
                                domProps: { value: _vm.value.name2 },
                                on: {
                                  input: function ($event) {
                                    var inputValue = $event.target.value
                                    _vm.emitInputEvent(
                                      "name2",
                                      $event.target.value
                                    )
                                    _vm.clearTimer("FN1")
                                    _vm.setTimer("FN1", function () {
                                      _vm.isAddressEmpty(
                                        inputValue,
                                        "firstName",
                                        1
                                      )
                                    })
                                  },
                                  blur: function ($event) {
                                    _vm.clearTimer("FN1")
                                    _vm.isAddressEmpty(
                                      $event.target.value,
                                      "firstName",
                                      1
                                    )
                                  },
                                  keypress: function ($event) {
                                    return _vm.filterCharacters($event)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "txtFirstName" + _vm._uid } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.addressFirstName"
                                      )
                                    ) + "\n                                "
                                  ),
                                  _vm.areNameFieldsRequired(
                                    "de",
                                    "billing_address"
                                  )
                                    ? [_vm._v("*")]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-sm-4" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate:text",
                                  value: _vm.areNameFieldsRequired(
                                    "de",
                                    "billing_address"
                                  ),
                                  expression:
                                    "\n                                areNameFieldsRequired(\n                                    'de',\n                                    'billing_address'\n                                )\n                            ",
                                  arg: "text",
                                },
                              ],
                              staticClass: "input-unit",
                              class: {
                                "error-without-z":
                                  _vm.isLastNameValid1 === false,
                                "success-without-z":
                                  _vm.isLastNameValid1 === true,
                              },
                              attrs: { "data-model": "name3" },
                            },
                            [
                              _c("input", {
                                attrs: {
                                  id: "txtLastName" + _vm._uid,
                                  "data-testing": "billing-address-de-lastname",
                                  inputmode: "text",
                                  maxlength: "19",
                                  name: "lastName",
                                  type: "text",
                                },
                                domProps: { value: _vm.value.name3 },
                                on: {
                                  input: function ($event) {
                                    var inputValue = $event.target.value
                                    _vm.emitInputEvent(
                                      "name3",
                                      $event.target.value
                                    )
                                    _vm.clearTimer("LN1")
                                    _vm.setTimer("LN1", function () {
                                      _vm.isAddressEmpty(
                                        inputValue,
                                        "lastName",
                                        1
                                      )
                                    })
                                  },
                                  blur: function ($event) {
                                    _vm.clearTimer("LN1")
                                    _vm.isAddressEmpty(
                                      $event.target.value,
                                      "lastName",
                                      1
                                    )
                                  },
                                  keypress: function ($event) {
                                    return _vm.filterCharacters($event)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "txtLastName" + _vm._uid } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.addressLastName"
                                      )
                                    ) + "\n                                "
                                  ),
                                  _vm.areNameFieldsRequired(
                                    "de",
                                    "billing_address"
                                  )
                                    ? [_vm._v("*")]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          ),
                        ]),
                      ]
                    : _c("div", { staticClass: "col-12 col-sm-8" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate:text",
                                value: _vm.isInRequiredFields(
                                  "de",
                                  "billing_address.contactPerson"
                                ),
                                expression:
                                  "\n                            isInRequiredFields(\n                                'de',\n                                'billing_address.contactPerson'\n                            )\n                        ",
                                arg: "text",
                              },
                            ],
                            staticClass: "input-unit",
                            attrs: { "data-model": "contactPerson" },
                          },
                          [
                            _c("input", {
                              attrs: {
                                id: "txtContactPerson" + _vm._uid,
                                inputmode: "text",
                                maxlength: "19",
                                name: "lastName",
                                type: "text",
                              },
                              domProps: { value: _vm.value.contactPerson },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInputEvent(
                                    "contactPerson",
                                    $event.target.value
                                  )
                                },
                                keypress: function ($event) {
                                  return _vm.filterCharacters($event)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "txtContactPerson" + _vm._uid } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.transformTranslation(
                                        "Ceres::Template.addressContactPerson",
                                        "de",
                                        "billing_address.contactPerson"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                  _vm._v(" "),
                  _vm.isInOptionalFields("de", "billing_address.name4")
                    ? _c("div", { staticClass: "col-12 col-sm-4" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate:text",
                                value: _vm.isInRequiredFields(
                                  "de",
                                  "billing_address.name4"
                                ),
                                expression:
                                  "\n                            isInRequiredFields(\n                                'de',\n                                'billing_address.name4'\n                            )\n                        ",
                                arg: "text",
                              },
                            ],
                            staticClass: "input-unit",
                            attrs: { "data-model": "name4" },
                          },
                          [
                            _c("input", {
                              attrs: {
                                id: "txtAdditionalName" + _vm._uid,
                                inputmode: "text",
                                maxlength: "30",
                                name: "decorateName",
                                type: "text",
                              },
                              domProps: { value: _vm.value.name4 },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInputEvent(
                                    "name4",
                                    $event.target.value
                                  )
                                },
                                keypress: function ($event) {
                                  return _vm.filterCharacters($event)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                attrs: { for: "txtAdditionalName" + _vm._uid },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.transformTranslation(
                                        "Ceres::Template.addressAdditionalName",
                                        "de",
                                        "billing_address.name4"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isInOptionalFields("de", "billing_address.birthday")
                    ? _c("div", { staticClass: "col-12 col-sm-4" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate:date",
                                value:
                                  _vm.isInRequiredFields(
                                    "de",
                                    "billing_address.birthday"
                                  ) ||
                                  (!!_vm.value.birthday &&
                                    !!_vm.value.birthday.length),
                                expression:
                                  "\n                            isInRequiredFields(\n                                'de',\n                                'billing_address.birthday'\n                            ) ||\n                            (!!value.birthday && !!value.birthday.length)\n                        ",
                                arg: "date",
                              },
                            ],
                            staticClass: "input-unit",
                            attrs: { "data-model": "birthday" },
                          },
                          [
                            _c("input", {
                              attrs: {
                                id: "txtBirthdate" + _vm._uid,
                                max: new Date().toISOString().split("T")[0],
                                placeholder: _vm.$translate(
                                  "Ceres::Template.addressBirthdatePlaceholder"
                                ),
                                min: "1901-12-14",
                                name: "birthday",
                                type: "date",
                              },
                              domProps: { value: _vm.value.birthday },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInputEvent(
                                    "birthday",
                                    $event.target.value
                                  )
                                },
                                keypress: function ($event) {
                                  return _vm.filterCharacters($event)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "txtBirthdate" + _vm._uid } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.transformTranslation(
                                        "Ceres::Template.addressBirthdate",
                                        "de",
                                        "billing_address.birthday"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                (_vm.isInOptionalFields("de", "billing_address.salutation") &&
                  _vm.value.gender === "company") ||
                (_vm.isInOptionalFields("de", "billing_address.name1") &&
                  !_vm.isInOptionalFields("de", "billing_address.salutation"))
                  ? _c("div", { staticClass: "col-12 col-sm-6" }, [
                      _c(
                        "div",
                        {
                          staticClass: "input-unit",
                          class: {
                            "error-without-z": _vm.isCompanyValid1 === false,
                            "success-without-z": _vm.isCompanyValid1 === true,
                          },
                          attrs: {
                            "data-model": "name1",
                            "data-validate": "text",
                          },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "txtCompany" + _vm._uid,
                              "data-autofocus": "",
                              "data-testing": "billing-address-de-company",
                              inputmode: "text",
                              maxlength: "30",
                              name: "company",
                              type: "text",
                            },
                            domProps: { value: _vm.value.name1 },
                            on: {
                              input: function ($event) {
                                _vm.emitInputEvent("name1", $event.target.value)
                                _vm.clearTimer("C1")
                                _vm.setTimer("C1", function () {
                                  _vm.isAddressEmpty(
                                    $event.target.value,
                                    "company",
                                    1
                                  )
                                })
                              },
                              blur: function ($event) {
                                _vm.clearTimer("C1")
                                _vm.isAddressEmpty(
                                  $event.target.value,
                                  "company",
                                  1
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "txtCompany" + _vm._uid } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.addressCompany"
                                  )
                                ) + "*"
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-sm-6" },
                  [
                    _c("vat-id", {
                      attrs: {
                        "is-required": _vm.isInRequiredFields(
                          "de",
                          "billing_address.vatNumber"
                        ),
                        "selected-country-id": _vm.value.countryId,
                        "show-input":
                          (_vm.isInOptionalFields(
                            "de",
                            "billing_address.salutation"
                          ) &&
                            _vm.value.gender === "company" &&
                            _vm.isInOptionalFields(
                              "de",
                              "billing_address.vatNumber"
                            )) ||
                          (!_vm.isInOptionalFields(
                            "de",
                            "billing_address.salutation"
                          ) &&
                            _vm.isInOptionalFields(
                              "de",
                              "billing_address.name1"
                            ) &&
                            _vm.isInOptionalFields(
                              "de",
                              "billing_address.vatNumber"
                            )),
                        value: _vm.value.vatNumber || "",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.emitInputEvent("vatNumber", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-12",
                attrs: { "data-testing": "billing-address-de-name-inputs" },
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass: "col-6",
                      attrs: {
                        "data-testing": "billing-address-de-street-inputs",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "input-unit",
                          class: {
                            "error-without-z": _vm.isStreetNameValid1 === false,
                            "success-without-z":
                              _vm.isStreetNameValid1 === true,
                          },
                          attrs: {
                            "data-model": "address1",
                            "data-validate": "text",
                          },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "txtStreet" + _vm._uid,
                              autocomplete: "address-line1",
                              "data-testing": "billing-address-de-street",
                              inputmode: "text",
                              maxlength: "30",
                              name: "street",
                              type: "text",
                            },
                            domProps: { value: _vm.value.address1 },
                            on: {
                              input: function ($event) {
                                var inputValue = $event.target.value
                                _vm.emitInputEvent(
                                  "address1",
                                  $event.target.value
                                )
                                _vm.clearTimer("SN1")
                                _vm.setTimer("SN1", function () {
                                  _vm.isAddressEmpty(inputValue, "street", 1)
                                })
                              },
                              blur: function ($event) {
                                _vm.clearTimer("SN1")
                                _vm.isAddressEmpty(
                                  $event.target.value,
                                  "street",
                                  1
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "txtStreet" + _vm._uid } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.addressStreet"
                                  )
                                ) + "*"
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-2" }, [
                    _c(
                      "div",
                      {
                        staticClass: "input-unit",
                        class: {
                          "error-without-z": _vm.isHouseNumberValid1 === false,
                          "success-without-z": _vm.isHouseNumberValid1 === true,
                        },
                        attrs: {
                          "data-model": "address2",
                          "data-validate": "text",
                        },
                      },
                      [
                        _c("input", {
                          attrs: {
                            id: "txtNumber" + _vm._uid,
                            autocomplete: "address-line2",
                            "data-testing": "billing-address-de-house-number",
                            inputmode: "text",
                            maxlength: "30",
                            name: "housenumber",
                            type: "text",
                          },
                          domProps: { value: _vm.value.address2 },
                          on: {
                            input: function ($event) {
                              var inputValue = $event.target.value
                              _vm.emitInputEvent(
                                "address2",
                                $event.target.value
                              )
                              _vm.clearTimer("HN1")
                              _vm.setTimer("HN1", function () {
                                _vm.isAddressEmpty(inputValue, "houseNumber", 1)
                              })
                            },
                            blur: function ($event) {
                              _vm.clearTimer("HN1")
                              _vm.isAddressEmpty(
                                $event.target.value,
                                "houseNumber",
                                1
                              )
                            },
                            keypress: function ($event) {
                              return _vm.filterCharacters($event)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          { attrs: { for: "txtNumber" + _vm._uid } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$translate("Ceres::Template.addressNumber")
                              ) + "*"
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.isInOptionalFields("de", "billing_address.phoneNumber")
                    ? _c("div", { staticClass: "col-4" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate:text",
                                value: _vm.isInRequiredFields(
                                  "de",
                                  "billing_address.phoneNumber"
                                ),
                                expression:
                                  "\n                            isInRequiredFields(\n                                'de',\n                                'billing_address.phoneNumber'\n                            )\n                        ",
                                arg: "text",
                              },
                            ],
                            staticClass: "input-unit",
                            attrs: { "data-model": "telephone" },
                          },
                          [
                            _c("input", {
                              attrs: {
                                id: "txtTelephone" + _vm._uid,
                                inputmode: "tel",
                                maxlength: "30",
                                name: "telephone",
                                type: "tel",
                              },
                              domProps: { value: _vm.value.telephone },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInputEvent(
                                    "telephone",
                                    $event.target.value
                                  )
                                },
                                keypress: function ($event) {
                                  return _vm.filterCharacters($event)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "txtTelephone" + _vm._uid } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.transformTranslation(
                                        "Ceres::Template.addressTelephone",
                                        "de",
                                        "billing_address.phoneNumber"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                _vm.isInOptionalFields("de", "billing_address.address3")
                  ? _c("div", { staticClass: "col-12 col-sm-6" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate:text",
                              value: _vm.isInRequiredFields(
                                "de",
                                "billing_address.address3"
                              ),
                              expression:
                                "\n                            isInRequiredFields(\n                                'de',\n                                'billing_address.address3'\n                            )\n                        ",
                              arg: "text",
                            },
                          ],
                          staticClass: "input-unit",
                          attrs: { "data-model": "address3" },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "decorateAddress0" + _vm._uid,
                              inputmode: "text",
                              maxlength: "30",
                              name: "decorateAddress",
                              type: "text",
                            },
                            domProps: { value: _vm.value.address3 },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  "address3",
                                  $event.target.value
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "decorateAddress0" + _vm._uid } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.transformTranslation(
                                      "Ceres::Template.addressAdditionalAddress1",
                                      "de",
                                      "billing_address.address3"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isInOptionalFields("de", "billing_address.address4")
                  ? _c("div", { staticClass: "col-12 col-sm-6" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate:text",
                              value: _vm.isInRequiredFields(
                                "de",
                                "billing_address.address4"
                              ),
                              expression:
                                "\n                            isInRequiredFields(\n                                'de',\n                                'billing_address.address4'\n                            )\n                        ",
                              arg: "text",
                            },
                          ],
                          staticClass: "input-unit",
                          attrs: { "data-model": "address4" },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "decorateAddress1" + _vm._uid,
                              inputmode: "text",
                              maxlength: "30",
                              name: "decorateAddress",
                              type: "text",
                            },
                            domProps: { value: _vm.value.address4 },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  "address4",
                                  $event.target.value
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "decorateAddress1" + _vm._uid } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.transformTranslation(
                                      "Ceres::Template.addressAdditionalAddress2",
                                      "de",
                                      "billing_address.address4"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-sm-4" }, [
              _c(
                "div",
                {
                  staticClass: "input-unit",
                  class: {
                    "error-without-z": _vm.isPostalCodeValid1 === false,
                    "success-without-z": _vm.isPostalCodeValid1 === true,
                  },
                  attrs: {
                    "data-model": "postalCode",
                    "data-validate": "postalCode",
                  },
                },
                [
                  _c("input", {
                    staticClass: "postalCodeCustom",
                    attrs: {
                      id: "txtZip" + _vm._uid,
                      "data-testing": "billing-address-de-zip",
                      inputmode: "numeric",
                      maxlength: "4",
                      name: "zip",
                      type: "text",
                      pattern: ".{4,4}",
                    },
                    domProps: { value: _vm.value.postalCode },
                    on: {
                      input: function ($event) {
                        var inputValue = $event.target.value
                        _vm.emitInputEvent("postalCode", $event.target.value)
                        _vm.clearTimer("ZIP1")
                        _vm.setTimer("ZIP1", function () {
                          _vm.validatePostalCode(inputValue, 1)
                        })
                      },
                      blur: function ($event) {
                        _vm.clearTimer("ZIP1")
                        _vm.validatePostalCode($event.target.value, 1)
                      },
                      keypress: function ($event) {
                        return _vm.onlyNumbers("postalCode", _vm._uid, $event)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "txtZip" + _vm._uid } }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$translate("Ceres::Template.addressZip")) +
                        "*\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "errTxtZip" + _vm._uid,
                      staticClass:
                        "errmsg text-danger position-absolute small mt-1",
                      staticStyle: { display: "none" },
                      attrs: { id: "errTxtZip" + _vm._uid },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate(
                              "GonserDT::Template.checkoutOnlyNumbers"
                            )
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "errTxtZipLength bg-warning p-3" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$translate("GonserDT::Template.checkoutZipLength")
                        ) +
                        "\n                "
                    ),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-sm-4" }, [
              _c(
                "div",
                {
                  staticClass: "input-unit",
                  class: {
                    "error-without-z": _vm.isTownValid1 === false,
                    "success-without-z": _vm.isTownValid1 === true,
                  },
                  attrs: { "data-model": "town", "data-validate": "text" },
                },
                [
                  _c("input", {
                    attrs: {
                      id: "txtPlace" + _vm._uid,
                      "data-testing": "billing-address-de-town",
                      inputmode: "text",
                      maxlength: "30",
                      name: "town",
                      type: "text",
                    },
                    domProps: { value: _vm.value.town },
                    on: {
                      input: function ($event) {
                        var inputValue = $event.target.value
                        _vm.emitInputEvent("town", $event.target.value)
                        _vm.clearTimer("T1")
                        _vm.setTimer("T1", function () {
                          _vm.isAddressEmpty(inputValue, "town", 1)
                        })
                      },
                      blur: function ($event) {
                        _vm.clearTimer("T1")
                        _vm.isAddressEmpty($event.target.value, "town", 1)
                      },
                      keypress: function ($event) {
                        return _vm.filterCharacters($event)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "txtPlace" + _vm._uid } }, [
                    _vm._v(
                      _vm._s(_vm.$translate("Ceres::Template.addressPlace")) +
                        "*"
                    ),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-12 col-sm-4",
                attrs: { "data-testing": "address-country-select" },
              },
              [
                _c("country-select", {
                  attrs: {
                    "address-type": _vm.addressType,
                    "optional-address-fields": _vm.optionalAddressFields,
                    "required-address-fields": _vm.requiredAddressFields,
                    specificCountryIds: [4, 34],
                    "selected-country-id": _vm.value.countryId,
                    "selected-state-id": _vm.value.stateId,
                  },
                  on: {
                    "country-changed": function ($event) {
                      return _vm.onSelectedCountryChanged($event)
                    },
                    "state-changed": function ($event) {
                      return _vm.emitInputEvent("stateId", $event)
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm._t("custom-address-fields"),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c("hr", { staticClass: "mt-0" }),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _vm.isInOptionalFields("de", "billing_address.email")
                  ? _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate:text",
                              value: _vm.isInRequiredFields(
                                "de",
                                "billing_address.email"
                              ),
                              expression:
                                "\n                            isInRequiredFields(\n                                'de',\n                                'billing_address.email'\n                            )\n                        ",
                              arg: "text",
                            },
                          ],
                          staticClass: "input-unit",
                          attrs: { "data-model": "email" },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "email" + _vm._uid,
                              "data-testing": "billing-address-de-email-input",
                              inputmode: "email",
                              maxlength: "30",
                              name: "email",
                              type: "mail",
                            },
                            domProps: { value: _vm.value.email },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  "email",
                                  $event.target.value
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "email" + _vm._uid } }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.transformTranslation(
                                    "Ceres::Template.addressMail",
                                    "de",
                                    "billing_address.email"
                                  )
                                ) +
                                "\n                        "
                            ),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]
        : _vm.localeToShow == "GB" && _vm.addressType === "1"
        ? [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                _vm.isInOptionalFields("gb", "billing_address.salutation")
                  ? _c("div", { staticClass: "col-12 col-sm-4" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.isInRequiredFields(
                                "gb",
                                "billing_address.salutation"
                              ),
                              expression:
                                "\n                            isInRequiredFields(\n                                'gb',\n                                'billing_address.salutation'\n                            )\n                        ",
                            },
                          ],
                          staticClass: "input-unit",
                        },
                        [
                          _c("salutation-select", {
                            attrs: {
                              id: "txtSalutation" + _vm._uid,
                              "address-data": _vm.value,
                              "address-type": _vm.addressType,
                              "enabled-address-fields":
                                _vm.optionalAddressFields,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  $event.field,
                                  $event.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "txtSalutation" + _vm._uid } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.transformTranslation(
                                      "Ceres::Template.addressSalutation",
                                      "gb",
                                      "billing_address.salutation"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                (_vm.isInOptionalFields("gb", "billing_address.salutation") &&
                  _vm.value.gender === "company") ||
                (_vm.isInOptionalFields("gb", "billing_address.name1") &&
                  !_vm.isInOptionalFields("gb", "billing_address.salutation"))
                  ? _c("div", { staticClass: "col-12 col-sm-6" }, [
                      _c(
                        "div",
                        {
                          staticClass: "input-unit",
                          attrs: {
                            "data-model": "name1",
                            "data-validate": "text",
                          },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "txtCompany" + _vm._uid,
                              "data-autofocus": "",
                              inputmode: "text",
                              maxlength: "30",
                              name: "company",
                              type: "text",
                            },
                            domProps: { value: _vm.value.name1 },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  "name1",
                                  $event.target.value
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "txtCompany" + _vm._uid } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.addressCompany"
                                    )
                                  ) +
                                  "*\n                        "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-sm-6" },
                  [
                    _c("vat-id", {
                      attrs: {
                        "is-required": _vm.isInRequiredFields(
                          "gb",
                          "billing_address.vatNumber"
                        ),
                        "selected-country-id": _vm.value.countryId,
                        "show-input":
                          (_vm.isInOptionalFields(
                            "gb",
                            "billing_address.salutation"
                          ) &&
                            _vm.value.gender === "company" &&
                            _vm.isInOptionalFields(
                              "gb",
                              "billing_address.vatNumber"
                            )) ||
                          (!_vm.isInOptionalFields(
                            "gb",
                            "billing_address.salutation"
                          ) &&
                            _vm.isInOptionalFields(
                              "gb",
                              "billing_address.name1"
                            ) &&
                            _vm.isInOptionalFields(
                              "gb",
                              "billing_address.vatNumber"
                            )),
                        value: _vm.value.vatNumber || "",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.emitInputEvent("vatNumber", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c(
                "div",
                { staticClass: "row" },
                [
                  _vm.isInOptionalFields("gb", "billing_address.title")
                    ? _c("div", { staticClass: "col-12 col-sm-4" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate:text",
                                value: _vm.isInRequiredFields(
                                  "gb",
                                  "billing_address.title"
                                ),
                                expression:
                                  "\n                            isInRequiredFields(\n                                'gb',\n                                'billing_address.title'\n                            )\n                        ",
                                arg: "text",
                              },
                            ],
                            staticClass: "input-unit",
                            attrs: { "data-model": "title" },
                          },
                          [
                            _c("input", {
                              attrs: {
                                id: "txtTitle" + _vm._uid,
                                "data-autofocus": "",
                                inputmode: "text",
                                maxlength: "30",
                                name: "title",
                                type: "text",
                              },
                              domProps: { value: _vm.value.title },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInputEvent(
                                    "title",
                                    $event.target.value
                                  )
                                },
                                keypress: function ($event) {
                                  return _vm.filterCharacters($event)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "txtTitle" + _vm._uid } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.transformTranslation(
                                        "Ceres::Template.addressTitle",
                                        "gb",
                                        "billing_address.title"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.areNameFieldsShown("gb", "billing_address")
                    ? [
                        _c("div", { staticClass: "col-12 col-sm-4" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate:text",
                                  value: _vm.areNameFieldsRequired(
                                    "gb",
                                    "billing_address"
                                  ),
                                  expression:
                                    "\n                                areNameFieldsRequired(\n                                    'gb',\n                                    'billing_address'\n                                )\n                            ",
                                  arg: "text",
                                },
                              ],
                              staticClass: "input-unit",
                              attrs: { "data-model": "name2" },
                            },
                            [
                              _c("input", {
                                attrs: {
                                  id: "txtFirstName" + _vm._uid,
                                  "data-autofocus": "",
                                  "data-model": "name2",
                                  inputmode: "text",
                                  maxlength: "19",
                                  name: "firstName",
                                  type: "text",
                                },
                                domProps: { value: _vm.value.name2 },
                                on: {
                                  input: function ($event) {
                                    return _vm.emitInputEvent(
                                      "name2",
                                      $event.target.value
                                    )
                                  },
                                  keypress: function ($event) {
                                    return _vm.filterCharacters($event)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "txtFirstName" + _vm._uid } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.addressFirstName"
                                      )
                                    ) + "\n                                "
                                  ),
                                  _vm.areNameFieldsRequired(
                                    "gb",
                                    "billing_address"
                                  )
                                    ? [_vm._v("*")]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-sm-4" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate:text",
                                  value: _vm.areNameFieldsRequired(
                                    "gb",
                                    "billing_address"
                                  ),
                                  expression:
                                    "\n                                areNameFieldsRequired(\n                                    'gb',\n                                    'billing_address'\n                                )\n                            ",
                                  arg: "text",
                                },
                              ],
                              staticClass: "input-unit",
                              attrs: { "data-model": "name3" },
                            },
                            [
                              _c("input", {
                                attrs: {
                                  id: "txtLastName" + _vm._uid,
                                  "data-model": "name3",
                                  inputmode: "text",
                                  maxlength: "19",
                                  name: "lastName",
                                  type: "text",
                                },
                                domProps: { value: _vm.value.name3 },
                                on: {
                                  input: function ($event) {
                                    return _vm.emitInputEvent(
                                      "name3",
                                      $event.target.value
                                    )
                                  },
                                  keypress: function ($event) {
                                    return _vm.filterCharacters($event)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "txtLastName" + _vm._uid } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.addressLastName"
                                      )
                                    ) + "\n                                "
                                  ),
                                  _vm.areNameFieldsRequired(
                                    "gb",
                                    "billing_address"
                                  )
                                    ? [_vm._v("*")]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          ),
                        ]),
                      ]
                    : _c("div", { staticClass: "col-12 col-sm-8" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate:text",
                                value: _vm.isInRequiredFields(
                                  "gb",
                                  "billing_address.contactPerson"
                                ),
                                expression:
                                  "\n                            isInRequiredFields(\n                                'gb',\n                                'billing_address.contactPerson'\n                            )\n                        ",
                                arg: "text",
                              },
                            ],
                            staticClass: "input-unit",
                            attrs: { "data-model": "contactPerson" },
                          },
                          [
                            _c("input", {
                              attrs: {
                                id: "txtContactPerson" + _vm._uid,
                                inputmode: "text",
                                maxlength: "19",
                                name: "lastName",
                                type: "text",
                              },
                              domProps: { value: _vm.value.contactPerson },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInputEvent(
                                    "contactPerson",
                                    $event.target.value
                                  )
                                },
                                keypress: function ($event) {
                                  return _vm.filterCharacters($event)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "txtContactPerson" + _vm._uid } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.transformTranslation(
                                        "Ceres::Template.addressContactPerson",
                                        "gb",
                                        "billing_address.contactPerson"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                  _vm._v(" "),
                  _vm.isInOptionalFields("gb", "billing_address.name4")
                    ? _c("div", { staticClass: "col-sm-4" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate:text",
                                value: _vm.isInRequiredFields(
                                  "gb",
                                  "billing_address.name4"
                                ),
                                expression:
                                  "\n                            isInRequiredFields(\n                                'gb',\n                                'billing_address.name4'\n                            )\n                        ",
                                arg: "text",
                              },
                            ],
                            staticClass: "input-unit",
                            attrs: { "data-model": "name4" },
                          },
                          [
                            _c("input", {
                              attrs: {
                                id: "txtAdditionalName" + _vm._uid,
                                inputmode: "text",
                                maxlength: "30",
                                name: "decorateName",
                                type: "text",
                              },
                              domProps: { value: _vm.value.name4 },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInputEvent(
                                    "name4",
                                    $event.target.value
                                  )
                                },
                                keypress: function ($event) {
                                  return _vm.filterCharacters($event)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                attrs: { for: "txtAdditionalName" + _vm._uid },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.transformTranslation(
                                        "Ceres::Template.addressGBNameAffix",
                                        "gb",
                                        "billing_address.name4"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isInOptionalFields("gb", "billing_address.birthday")
                    ? _c("div", { staticClass: "col-12 col-sm-4" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate:date",
                                value:
                                  _vm.isInRequiredFields(
                                    "gb",
                                    "billing_address.birthday"
                                  ) ||
                                  (!!_vm.value.birthday &&
                                    !!_vm.value.birthday.length),
                                expression:
                                  "\n                            isInRequiredFields(\n                                'gb',\n                                'billing_address.birthday'\n                            ) ||\n                            (!!value.birthday && !!value.birthday.length)\n                        ",
                                arg: "date",
                              },
                            ],
                            staticClass: "input-unit",
                            attrs: { "data-model": "birthday" },
                          },
                          [
                            _c("input", {
                              attrs: {
                                id: "txtBirthdate" + _vm._uid,
                                max: new Date().toISOString().split("T")[0],
                                placeholder: _vm.$translate(
                                  "Ceres::Template.addressBirthdatePlaceholder"
                                ),
                                min: "1901-12-14",
                                name: "birthday",
                                type: "date",
                              },
                              domProps: { value: _vm.value.birthday },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInputEvent(
                                    "birthday",
                                    $event.target.value
                                  )
                                },
                                keypress: function ($event) {
                                  return _vm.filterCharacters($event)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "txtBirthdate" + _vm._uid } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.transformTranslation(
                                        "Ceres::Template.addressBirthdate",
                                        "gb",
                                        "billing_address.birthday"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isInOptionalFields("gb", "billing_address.phoneNumber")
                    ? _c("div", { staticClass: "col-12 col-sm-4" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate:text",
                                value: _vm.isInRequiredFields(
                                  "gb",
                                  "billing_address.phoneNumber"
                                ),
                                expression:
                                  "\n                            isInRequiredFields(\n                                'gb',\n                                'billing_address.phoneNumber'\n                            )\n                        ",
                                arg: "text",
                              },
                            ],
                            staticClass: "input-unit",
                            attrs: { "data-model": "telephone" },
                          },
                          [
                            _c("input", {
                              attrs: {
                                id: "txtTelephone" + _vm._uid,
                                inputmode: "tel",
                                maxlength: "30",
                                name: "telephone",
                                type: "tel",
                              },
                              domProps: { value: _vm.value.telephone },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInputEvent(
                                    "telephone",
                                    $event.target.value
                                  )
                                },
                                keypress: function ($event) {
                                  return _vm.onlyNumbers(
                                    "telephone",
                                    _vm._uid,
                                    $event
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "txtTelephone" + _vm._uid } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.transformTranslation(
                                        "Ceres::Template.addressTelephone",
                                        "gb",
                                        "billing_address.phoneNumber"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-12",
                attrs: { "data-testing": "invoice-addresses-street-select-gb" },
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 col-sm-12" }, [
                    _c(
                      "div",
                      {
                        staticClass: "input-unit",
                        attrs: {
                          "data-model": "address1",
                          "data-validate": "text",
                        },
                      },
                      [
                        _c("input", {
                          attrs: {
                            id: "txtStreet" + _vm._uid,
                            autocomplete: "address-line1",
                            inputmode: "text",
                            maxlength: "30",
                            name: "street",
                            type: "text",
                          },
                          domProps: { value: _vm.value.address1 },
                          on: {
                            input: function ($event) {
                              return _vm.emitInputEvent(
                                "address1",
                                $event.target.value
                              )
                            },
                            keypress: function ($event) {
                              return _vm.filterCharacters($event)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          { attrs: { for: "txtStreet" + _vm._uid } },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.addressENAddressLine1"
                                  )
                                ) +
                                "*\n                        "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.isInOptionalFields("gb", "billing_address.address2")
                    ? _c("div", { staticClass: "col-12 col-sm-12" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate:text",
                                value: _vm.isInRequiredFields(
                                  "gb",
                                  "billing_address.address2"
                                ),
                                expression:
                                  "\n                            isInRequiredFields(\n                                'gb',\n                                'billing_address.address2'\n                            )\n                        ",
                                arg: "text",
                              },
                            ],
                            staticClass: "input-unit",
                            attrs: { "data-model": "address2" },
                          },
                          [
                            _c("input", {
                              attrs: {
                                id: "txtNumber" + _vm._uid,
                                autocomplete: "address-line2",
                                inputmode: "text",
                                maxlength: "30",
                                name: "housenumber",
                                type: "text",
                              },
                              domProps: { value: _vm.value.address2 },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInputEvent(
                                    "address2",
                                    $event.target.value
                                  )
                                },
                                keypress: function ($event) {
                                  return _vm.filterCharacters($event)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "txtNumber" + _vm._uid } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.transformTranslation(
                                        "Ceres::Template.addressENAddressLine2",
                                        "gb",
                                        "billing_address.address2"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                _vm.isInOptionalFields("gb", "billing_address.address3")
                  ? _c("div", { staticClass: "col-12 col-sm-12" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate:text",
                              value: _vm.isInRequiredFields(
                                "gb",
                                "billing_address.address3"
                              ),
                              expression:
                                "\n                            isInRequiredFields(\n                                'gb',\n                                'billing_address.address3'\n                            )\n                        ",
                              arg: "text",
                            },
                          ],
                          staticClass: "input-unit",
                          attrs: { "data-model": "address3" },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "decorateAddress0" + _vm._uid,
                              inputmode: "text",
                              maxlength: "30",
                              name: "buildingName",
                              type: "text",
                            },
                            domProps: { value: _vm.value.address3 },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  "address3",
                                  $event.target.value
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "decorateAddress0" + _vm._uid } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.transformTranslation(
                                      "Ceres::Template.addressENAddressLine3",
                                      "gb",
                                      "billing_address.address3"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isInOptionalFields("gb", "billing_address.address4")
                  ? _c("div", { staticClass: "col-12 col-sm-12" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate:text",
                              value: _vm.isInRequiredFields(
                                "gb",
                                "billing_address.address4"
                              ),
                              expression:
                                "\n                            isInRequiredFields(\n                                'gb',\n                                'billing_address.address4'\n                            )\n                        ",
                              arg: "text",
                            },
                          ],
                          staticClass: "input-unit",
                          attrs: { "data-model": "address4" },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "decorateAddress0" + _vm._uid,
                              inputmode: "text",
                              maxlength: "30",
                              name: "buildingName",
                              type: "text",
                            },
                            domProps: { value: _vm.value.address4 },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  "address4",
                                  $event.target.value
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "decorateAddress0" + _vm._uid } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.transformTranslation(
                                      "Ceres::Template.addressENAddressLine4",
                                      "gb",
                                      "billing_address.address4"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-sm-4" }, [
              _c(
                "div",
                {
                  staticClass: "input-unit",
                  attrs: { "data-model": "town", "data-validate": "text" },
                },
                [
                  _c("input", {
                    attrs: {
                      id: "txtPlace" + _vm._uid,
                      inputmode: "text",
                      maxlength: "30",
                      name: "town",
                      type: "text",
                    },
                    domProps: { value: _vm.value.town },
                    on: {
                      input: function ($event) {
                        return _vm.emitInputEvent("town", $event.target.value)
                      },
                      keypress: function ($event) {
                        return _vm.filterCharacters($event)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "txtPlace" + _vm._uid } }, [
                    _vm._v(
                      _vm._s(_vm.$translate("Ceres::Template.addressPlace")) +
                        "*"
                    ),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-sm-4" }, [
              _c(
                "div",
                {
                  staticClass: "input-unit",
                  attrs: {
                    "data-model": "postalCode",
                    "data-validate": "postalCode",
                  },
                },
                [
                  _c("input", {
                    attrs: {
                      id: "txtZip" + _vm._uid,
                      inputmode: "numeric",
                      maxlength: "4",
                      name: "zip",
                      type: "text",
                      pattern: ".{4,4}",
                    },
                    domProps: { value: _vm.value.postalCode },
                    on: {
                      input: function ($event) {
                        return _vm.emitInputEvent(
                          "postalCode",
                          $event.target.value
                        )
                      },
                      keypress: function ($event) {
                        return _vm.onlyNumbers("postalCode", _vm._uid, $event)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "txtZip" + _vm._uid } }, [
                    _vm._v(
                      _vm._s(_vm.$translate("Ceres::Template.addressZip")) + "*"
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "errTxtZip" + _vm._uid,
                      staticClass:
                        "errmsg test3 text-danger position-absolute small mt-1",
                      staticStyle: { display: "none" },
                      attrs: { id: "errTxtZip" + _vm._uid },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate(
                              "GonserDT::Template.checkoutOnlyNumbers"
                            )
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-12 col-sm-4",
                attrs: { "data-testing": "address-country-select" },
              },
              [
                _c("country-select", {
                  attrs: {
                    "address-type": _vm.addressType,
                    "optional-address-fields": _vm.optionalAddressFields,
                    "required-address-fields": _vm.requiredAddressFields,
                    specificCountryIds: [4, 34],
                    "selected-country-id": _vm.value.countryId,
                    "selected-state-id": _vm.value.stateId,
                  },
                  on: {
                    "country-changed": function ($event) {
                      return _vm.onSelectedCountryChanged($event)
                    },
                    "state-changed": function ($event) {
                      return _vm.emitInputEvent("stateId", $event)
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm._t("custom-address-fields"),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c("hr", { staticClass: "mt-0" }),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _vm.isInOptionalFields("gb", "billing_address.email")
                  ? _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate:text",
                              value: _vm.isInRequiredFields(
                                "gb",
                                "billing_address.email"
                              ),
                              expression:
                                "\n                            isInRequiredFields(\n                                'gb',\n                                'billing_address.email'\n                            )\n                        ",
                              arg: "text",
                            },
                          ],
                          staticClass: "input-unit",
                          attrs: { "data-model": "email" },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "email" + _vm._uid,
                              "data-testing": "billing-address-gb-email-input",
                              inputmode: "email",
                              name: "email",
                              type: "mail",
                            },
                            domProps: { value: _vm.value.email },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  "email",
                                  $event.target.value
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "email" + _vm._uid } }, [
                            _vm._v(
                              _vm._s(
                                _vm.transformTranslation(
                                  "Ceres::Template.addressMail",
                                  "gb",
                                  "billing_address.email"
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]
        : _vm.localeToShow == "DE" && _vm.addressType === "2" && _vm.isMobile
        ? [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                _vm.isInOptionalFields("de", "delivery_address.salutation")
                  ? _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.isInRequiredFields(
                                "de",
                                "delivery_address.salutation"
                              ),
                              expression:
                                "\n                            isInRequiredFields(\n                                'de',\n                                'delivery_address.salutation'\n                            )\n                        ",
                            },
                          ],
                          staticClass: "input-unit",
                        },
                        [
                          _c("salutation-select", {
                            attrs: {
                              id: "txtSalutation" + _vm._uid,
                              "address-data": _vm.value,
                              "address-type": _vm.addressType,
                              "enabled-address-fields":
                                _vm.optionalAddressFields,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  $event.field,
                                  $event.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "txtSalutation" + _vm._uid } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.transformTranslation(
                                      "Ceres::Template.addressSalutation",
                                      "de",
                                      "delivery_address.salutation"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                (_vm.isInOptionalFields("de", "delivery_address.salutation") &&
                  _vm.value.gender === "company") ||
                (_vm.isInOptionalFields("de", "delivery_address.name1") &&
                  !_vm.isInOptionalFields("de", "delivery_address.salutation"))
                  ? _c("div", { staticClass: "col-12 col-sm-6" }, [
                      _c(
                        "div",
                        {
                          staticClass: "input-unit",
                          class: {
                            "error-without-z":
                              _vm.isCompanyNameValid2 === false,
                            "success-without-z":
                              _vm.isCompanyNameValid2 === true,
                          },
                          attrs: {
                            "data-model": "name1",
                            "data-validate": "text",
                          },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "txtCompany" + _vm._uid,
                              "data-autofocus": "",
                              inputmode: "text",
                              maxlength: "30",
                              name: "company",
                              type: "text",
                            },
                            domProps: { value: _vm.value.name1 },
                            on: {
                              input: function ($event) {
                                _vm.emitInputEvent("name1", $event.target.value)
                                _vm.clearTimer("C2")
                                _vm.setTimer("C2", function () {
                                  _vm.isAddressEmpty(
                                    $event.target.value,
                                    "company",
                                    2
                                  )
                                })
                              },
                              blur: function ($event) {
                                _vm.clearTimer("C2")
                                _vm.isAddressEmpty(
                                  $event.target.value,
                                  "company",
                                  2
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "txtCompany" + _vm._uid } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.addressCompany"
                                  )
                                ) + "*"
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-sm-6" },
                  [
                    _c("vat-id", {
                      attrs: {
                        "is-required": _vm.isInRequiredFields(
                          "de",
                          "delivery_address.vatNumber"
                        ),
                        "selected-country-id": _vm.value.countryId,
                        "show-input":
                          (_vm.isInOptionalFields(
                            "de",
                            "delivery_address.salutation"
                          ) &&
                            _vm.value.gender === "company" &&
                            _vm.isInOptionalFields(
                              "de",
                              "delivery_address.vatNumber"
                            )) ||
                          (!_vm.isInOptionalFields(
                            "de",
                            "delivery_address.salutation"
                          ) &&
                            _vm.isInOptionalFields(
                              "de",
                              "delivery_address.name1"
                            ) &&
                            _vm.isInOptionalFields(
                              "de",
                              "delivery_address.vatNumber"
                            )),
                        value: _vm.value.vatNumber || "",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.emitInputEvent("vatNumber", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c(
                "div",
                { staticClass: "row" },
                [
                  _vm.isInOptionalFields("de", "delivery_address.title")
                    ? _c("div", { staticClass: "col-12 col-sm-4" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate:text",
                                value: _vm.isInRequiredFields(
                                  "de",
                                  "delivery_address.title"
                                ),
                                expression:
                                  "\n                            isInRequiredFields(\n                                'de',\n                                'delivery_address.title'\n                            )\n                        ",
                                arg: "text",
                              },
                            ],
                            staticClass: "input-unit",
                            attrs: { "data-model": "title" },
                          },
                          [
                            _c("input", {
                              attrs: {
                                id: "txtTitle" + _vm._uid,
                                "data-autofocus": "",
                                inputmode: "text",
                                maxlength: "30",
                                name: "title",
                                type: "text",
                              },
                              domProps: { value: _vm.value.title },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInputEvent(
                                    "title",
                                    $event.target.value
                                  )
                                },
                                keypress: function ($event) {
                                  return _vm.filterCharacters($event)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "txtTitle" + _vm._uid } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.transformTranslation(
                                        "Ceres::Template.addressTitle",
                                        "de",
                                        "delivery_address.title"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.areNameFieldsShown("de", "delivery_address")
                    ? [
                        _c("div", { staticClass: "col-12 col-sm-4" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate:text",
                                  value: _vm.areNameFieldsRequired(
                                    "de",
                                    "delivery_address"
                                  ),
                                  expression:
                                    "\n                                areNameFieldsRequired(\n                                    'de',\n                                    'delivery_address'\n                                )\n                            ",
                                  arg: "text",
                                },
                              ],
                              staticClass: "input-unit",
                              class: {
                                "error-without-z":
                                  _vm.isFirstNameValid2 === false,
                                "success-without-z":
                                  _vm.isFirstNameValid2 === true,
                              },
                              attrs: { "data-model": "name2" },
                            },
                            [
                              _c("input", {
                                attrs: {
                                  id: "txtFirstName" + _vm._uid,
                                  "data-autofocus": "",
                                  "data-testing":
                                    "delivery-address-de-firstname",
                                  inputmode: "text",
                                  maxlength: "19",
                                  name: "firstName",
                                  type: "text",
                                },
                                domProps: { value: _vm.value.name2 },
                                on: {
                                  input: function ($event) {
                                    var inputValue = $event.target.value
                                    _vm.emitInputEvent(
                                      "name2",
                                      $event.target.value
                                    )
                                    _vm.clearTimer("FN2")
                                    _vm.setTimer("FN2", function () {
                                      _vm.isAddressEmpty(
                                        inputValue,
                                        "firstName",
                                        2
                                      )
                                    })
                                  },
                                  blur: function ($event) {
                                    _vm.clearTimer("FN2")
                                    _vm.isAddressEmpty(
                                      $event.target.value,
                                      "firstName",
                                      2
                                    )
                                  },
                                  keypress: function ($event) {
                                    return _vm.filterCharacters($event)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "txtFirstName" + _vm._uid } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.addressFirstName"
                                      )
                                    ) + "\n                                "
                                  ),
                                  _vm.areNameFieldsRequired(
                                    "de",
                                    "delivery_address"
                                  )
                                    ? [_vm._v("*")]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-sm-4" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate:text",
                                  value: _vm.areNameFieldsRequired(
                                    "de",
                                    "delivery_address"
                                  ),
                                  expression:
                                    "\n                                areNameFieldsRequired(\n                                    'de',\n                                    'delivery_address'\n                                )\n                            ",
                                  arg: "text",
                                },
                              ],
                              staticClass: "input-unit",
                              class: {
                                "error-without-z":
                                  _vm.isLastNameValid2 === false,
                                "success-without-z":
                                  _vm.isLastNameValid2 === true,
                              },
                              attrs: { "data-model": "name3" },
                            },
                            [
                              _c("input", {
                                attrs: {
                                  id: "txtLastName" + _vm._uid,
                                  "data-testing":
                                    "delivery-address-de-lastname",
                                  inputmode: "text",
                                  maxlength: "19",
                                  name: "lastName",
                                  type: "text",
                                },
                                domProps: { value: _vm.value.name3 },
                                on: {
                                  input: function ($event) {
                                    var inputValue = $event.target.value
                                    _vm.emitInputEvent(
                                      "name3",
                                      $event.target.value
                                    )
                                    _vm.clearTimer("LN2")
                                    _vm.setTimer("LN2", function () {
                                      _vm.isAddressEmpty(
                                        inputValue,
                                        "lastName",
                                        2
                                      )
                                    })
                                  },
                                  blur: function ($event) {
                                    _vm.clearTimer("LN2")
                                    _vm.isAddressEmpty(
                                      $event.target.value,
                                      "lastName",
                                      2
                                    )
                                  },
                                  keypress: function ($event) {
                                    return _vm.filterCharacters($event)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "txtLastName" + _vm._uid } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.addressLastName"
                                      )
                                    ) + "\n                                "
                                  ),
                                  _vm.areNameFieldsRequired(
                                    "de",
                                    "delivery_address"
                                  )
                                    ? [_vm._v("*")]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          ),
                        ]),
                      ]
                    : _c("div", { staticClass: "col-12 col-sm-8" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate:text",
                                value: _vm.isInRequiredFields(
                                  "de",
                                  "delivery_address.contactPerson"
                                ),
                                expression:
                                  "\n                            isInRequiredFields(\n                                'de',\n                                'delivery_address.contactPerson'\n                            )\n                        ",
                                arg: "text",
                              },
                            ],
                            staticClass: "input-unit",
                            attrs: { "data-model": "contactPerson" },
                          },
                          [
                            _c("input", {
                              attrs: {
                                id: "txtContactPerson" + _vm._uid,
                                inputmode: "text",
                                maxlength: "19",
                                name: "lastName",
                                type: "text",
                              },
                              domProps: { value: _vm.value.contactPerson },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInputEvent(
                                    "contactPerson",
                                    $event.target.value
                                  )
                                },
                                keypress: function ($event) {
                                  return _vm.filterCharacters($event)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "txtContactPerson" + _vm._uid } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.transformTranslation(
                                        "Ceres::Template.addressContactPerson",
                                        "de",
                                        "delivery_address.contactPerson"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                  _vm._v(" "),
                  _vm.isInOptionalFields("de", "delivery_address.name4")
                    ? _c("div", { staticClass: "col-12 col-sm-4" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate:text",
                                value: _vm.isInRequiredFields(
                                  "de",
                                  "delivery_address.name4"
                                ),
                                expression:
                                  "\n                            isInRequiredFields(\n                                'de',\n                                'delivery_address.name4'\n                            )\n                        ",
                                arg: "text",
                              },
                            ],
                            staticClass: "input-unit",
                            attrs: { "data-model": "name4" },
                          },
                          [
                            _c("input", {
                              attrs: {
                                id: "txtAdditionalName" + _vm._uid,
                                inputmode: "text",
                                maxlength: "30",
                                name: "decorateName",
                                type: "text",
                              },
                              domProps: { value: _vm.value.name4 },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInputEvent(
                                    "name4",
                                    $event.target.value
                                  )
                                },
                                keypress: function ($event) {
                                  return _vm.filterCharacters($event)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                attrs: { for: "txtAdditionalName" + _vm._uid },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.transformTranslation(
                                        "Ceres::Template.addressAdditionalName",
                                        "de",
                                        "delivery_address.name4"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isInOptionalFields("de", "delivery_address.phoneNumber")
                    ? _c("div", { staticClass: "col-12 col-sm-4" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate:text",
                                value: _vm.isInRequiredFields(
                                  "de",
                                  "delivery_address.phoneNumber"
                                ),
                                expression:
                                  "\n                            isInRequiredFields(\n                                'de',\n                                'delivery_address.phoneNumber'\n                            )\n                        ",
                                arg: "text",
                              },
                            ],
                            staticClass: "input-unit",
                            attrs: { "data-model": "telephone" },
                          },
                          [
                            _c("input", {
                              attrs: {
                                id: "txtTelephone" + _vm._uid,
                                inputmode: "tel",
                                maxlength: "30",
                                name: "telephone",
                                type: "tel",
                              },
                              domProps: { value: _vm.value.telephone },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInputEvent(
                                    "telephone",
                                    $event.target.value
                                  )
                                },
                                keypress: function ($event) {
                                  return _vm.onlyNumbers(
                                    "telephone",
                                    _vm._uid,
                                    $event
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "txtTelephone" + _vm._uid } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.transformTranslation(
                                        "Ceres::Template.addressTelephone",
                                        "de",
                                        "delivery_address.phoneNumber"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _vm.isParcelOrOfficeAvailable
              ? _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("input", {
                        attrs: {
                          id: "showPickup" + _vm._uid,
                          name: "togglePickup",
                          type: "checkbox",
                        },
                        domProps: { checked: _vm.value.showPickupStation },
                        on: {
                          change: function ($event) {
                            return _vm.togglePickupStation(
                              $event.target.checked
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "showPickup" + _vm._uid } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$translate(
                              "Ceres::Template.addressToPickupStation"
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-sm-8" }, [
                  _c(
                    "div",
                    {
                      staticClass: "input-unit",
                      class: {
                        "error-without-z": _vm.isStreetNameValid2 === false,
                        "success-without-z": _vm.isStreetNameValid2 === true,
                      },
                      attrs: {
                        "data-model": "address1",
                        "data-validate": "text",
                      },
                    },
                    [
                      _c("input", {
                        attrs: {
                          id: "txtStreet" + _vm._uid,
                          autocomplete: "address-line1",
                          "data-testing": "delivery-address-de-street",
                          inputmode: "text",
                          maxlength: "30",
                          name: "street",
                          type: "text",
                        },
                        domProps: { value: _vm.value.address1 },
                        on: {
                          input: function ($event) {
                            var inputValue = $event.target.value
                            _vm.emitInputEvent("address1", $event.target.value)
                            _vm.clearTimer("SN2")
                            _vm.setTimer("SN2", function () {
                              _vm.isAddressEmpty(inputValue, "street", 2)
                            })
                          },
                          blur: function ($event) {
                            _vm.clearTimer("SN2")
                            _vm.isAddressEmpty($event.target.value, "street", 2)
                          },
                          keypress: function ($event) {
                            return _vm.filterCharacters($event)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "txtStreet" + _vm._uid } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("Ceres::Template.addressStreet")
                          ) + "*"
                        ),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-sm-4" }, [
                  _c(
                    "div",
                    {
                      staticClass: "input-unit",
                      class: {
                        "error-without-z": _vm.isHouseNumberValid2 === false,
                        "success-without-z": _vm.isHouseNumberValid2 === true,
                      },
                      attrs: {
                        "data-model": "address2",
                        "data-validate": "text",
                      },
                    },
                    [
                      _c("input", {
                        attrs: {
                          id: "txtNumber" + _vm._uid,
                          autocomplete: "address-line2",
                          "data-testing": "delivery-address-de-housenumber",
                          inputmode: "text",
                          maxlength: "30",
                          name: "housenumber",
                          type: "text",
                        },
                        domProps: { value: _vm.value.address2 },
                        on: {
                          input: function ($event) {
                            var inputValue = $event.target.value
                            _vm.emitInputEvent("address2", $event.target.value)
                            _vm.clearTimer("HN2")
                            _vm.setTimer("HN2", function () {
                              _vm.isAddressEmpty(inputValue, "houseNumber", 2)
                            })
                          },
                          blur: function ($event) {
                            _vm.clearTimer("HN2")
                            _vm.isAddressEmpty(
                              $event.target.value,
                              "houseNumber",
                              2
                            )
                          },
                          keypress: function ($event) {
                            return _vm.filterCharacters($event)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "txtNumber" + _vm._uid } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("Ceres::Template.addressNumber")
                          ) + "*"
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                _vm.isInOptionalFields("de", "delivery_address.address3")
                  ? _c("div", { staticClass: "col-12 col-sm-6" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate:text",
                              value: _vm.isInRequiredFields(
                                "de",
                                "delivery_address.address3"
                              ),
                              expression:
                                "\n                            isInRequiredFields(\n                                'de',\n                                'delivery_address.address3'\n                            )\n                        ",
                              arg: "text",
                            },
                          ],
                          staticClass: "input-unit",
                          attrs: { "data-model": "address3" },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "decorateAddress0" + _vm._uid,
                              inputmode: "text",
                              maxlength: "30",
                              name: "decorateAddress",
                              type: "text",
                            },
                            domProps: { value: _vm.value.address3 },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  "address3",
                                  $event.target.value
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "decorateAddress0" + _vm._uid } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.transformTranslation(
                                      "Ceres::Template.addressAdditionalAddress1",
                                      "de",
                                      "delivery_address.address3"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isInOptionalFields("de", "delivery_address.address4")
                  ? _c("div", { staticClass: "col-12 col-sm-6" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate:text",
                              value: _vm.isInRequiredFields(
                                "de",
                                "delivery_address.address4"
                              ),
                              expression:
                                "\n                            isInRequiredFields(\n                                'de',\n                                'delivery_address.address4'\n                            )\n                        ",
                              arg: "text",
                            },
                          ],
                          staticClass: "input-unit",
                          attrs: { "data-model": "address4" },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "decorateAddress1" + _vm._uid,
                              inputmode: "text",
                              maxlength: "30",
                              name: "decorateAddress",
                              type: "text",
                            },
                            domProps: { value: _vm.value.address4 },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  "address4",
                                  $event.target.value
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "decorateAddress1" + _vm._uid } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.transformTranslation(
                                      "Ceres::Template.addressAdditionalAddress2",
                                      "de",
                                      "delivery_address.address4"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-sm-4" }, [
              _c(
                "div",
                {
                  staticClass: "input-unit",
                  class: {
                    "error-without-z": _vm.isPostalCodeValid2 === false,
                    "success-without-z": _vm.isPostalCodeValid2 === true,
                  },
                  attrs: {
                    "data-model": "postalCode",
                    "data-validate": "postalCode",
                  },
                },
                [
                  _c("input", {
                    staticClass: "postalCodeCustomDelivery",
                    attrs: {
                      id: "txtZip" + _vm._uid,
                      "data-testing": "delivery-address-de-zip",
                      inputmode: "numeric",
                      maxlength: "4",
                      name: "zip",
                      type: "text",
                      pattern: ".{4,4}",
                    },
                    domProps: { value: _vm.value.postalCode },
                    on: {
                      input: function ($event) {
                        var inputValue = $event.target.value
                        _vm.emitInputEvent("postalCode", $event.target.value)
                        _vm.clearTimer("ZIP2")
                        _vm.setTimer("ZIP2", function () {
                          _vm.validatePostalCode(inputValue, 2)
                        })
                      },
                      blur: function ($event) {
                        _vm.clearTimer("ZIP2")
                        _vm.validatePostalCode($event.target.value, 2)
                      },
                      keypress: function ($event) {
                        return _vm.onlyNumbers("postalCode", _vm._uid, $event)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "txtZip" + _vm._uid } }, [
                    _vm._v(
                      _vm._s(_vm.$translate("Ceres::Template.addressZip")) + "*"
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "errTxtZip" + _vm._uid,
                      staticClass:
                        "errmsg test4 text-danger position-absolute small mt-1",
                      staticStyle: { display: "none" },
                      attrs: { id: "errTxtZip" + _vm._uid },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate(
                              "GonserDT::Template.checkoutOnlyNumbers"
                            )
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "errTxtZipLengthDelivery bg-warning p-3" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate(
                              "GonserDT::Template.checkoutZipLength"
                            )
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-sm-4" }, [
              _c(
                "div",
                {
                  staticClass: "input-unit",
                  class: {
                    "error-without-z": _vm.isTownValid2 === false,
                    "success-without-z": _vm.isTownValid2 === true,
                  },
                  attrs: { "data-model": "town", "data-validate": "text" },
                },
                [
                  _c("input", {
                    attrs: {
                      id: "txtPlace" + _vm._uid,
                      "data-testing": "delivery-address-de-town",
                      inputmode: "text",
                      maxlength: "30",
                      name: "town",
                      type: "text",
                    },
                    domProps: { value: _vm.value.town },
                    on: {
                      input: function ($event) {
                        var inputValue = $event.target.value
                        _vm.emitInputEvent("town", $event.target.value)
                        _vm.clearTimer("T2")
                        _vm.setTimer("T2", function () {
                          _vm.isAddressEmpty(inputValue, "town", 2)
                        })
                      },
                      blur: function ($event) {
                        _vm.clearTimer("T2")
                        _vm.isAddressEmpty($event.target.value, "town", 2)
                      },
                      keypress: function ($event) {
                        return _vm.filterCharacters($event)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "txtPlace" + _vm._uid } }, [
                    _vm._v(
                      _vm._s(_vm.$translate("Ceres::Template.addressPlace")) +
                        "*"
                    ),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-12 col-sm-4",
                attrs: { "data-testing": "address-country-select" },
              },
              [
                _c("country-select", {
                  attrs: {
                    "address-type": _vm.addressType,
                    "optional-address-fields": _vm.optionalAddressFields,
                    "required-address-fields": _vm.requiredAddressFields,
                    specificCountryIds: [4, 34],
                    "selected-country-id": _vm.value.countryId,
                    "selected-state-id": _vm.value.stateId,
                  },
                  on: {
                    "country-changed": function ($event) {
                      return _vm.onSelectedCountryChanged($event)
                    },
                    "state-changed": function ($event) {
                      return _vm.emitInputEvent("stateId", $event)
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm._t("custom-address-fields"),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c("hr", { staticClass: "mt-0" }),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _vm.isInOptionalFields("de", "delivery_address.email")
                  ? _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate:text",
                              value: _vm.isInRequiredFields(
                                "de",
                                "delivery_address.email"
                              ),
                              expression:
                                "\n                            isInRequiredFields(\n                                'de',\n                                'delivery_address.email'\n                            )\n                        ",
                              arg: "text",
                            },
                          ],
                          staticClass: "input-unit",
                          attrs: { "data-model": "email" },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "email" + _vm._uid,
                              "data-testing": "delivery-address-de-email-input",
                              inputmode: "email",
                              maxlength: "30",
                              name: "email",
                              type: "mail",
                            },
                            domProps: { value: _vm.value.email },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  "email",
                                  $event.target.value
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "email" + _vm._uid } }, [
                            _vm._v(
                              _vm._s(
                                _vm.transformTranslation(
                                  "Ceres::Template.addressMail",
                                  "de",
                                  "delivery_address.email"
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]
        : _vm.localeToShow == "DE" && _vm.addressType === "2" && !_vm.isMobile
        ? [
            _c("div", { staticClass: "col-12" }, [
              _c(
                "div",
                { staticClass: "row" },
                [
                  _vm.isInOptionalFields("de", "delivery_address.salutation")
                    ? _c("div", { staticClass: "col-12 col-sm-4" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: _vm.isInRequiredFields(
                                  "de",
                                  "delivery_address.salutation"
                                ),
                                expression:
                                  "\n                            isInRequiredFields(\n                                'de',\n                                'delivery_address.salutation'\n                            )\n                        ",
                              },
                            ],
                            staticClass: "input-unit",
                          },
                          [
                            _c("salutation-select", {
                              attrs: {
                                id: "txtSalutation" + _vm._uid,
                                "address-data": _vm.value,
                                "address-type": _vm.addressType,
                                "enabled-address-fields":
                                  _vm.optionalAddressFields,
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInputEvent(
                                    $event.field,
                                    $event.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "txtSalutation" + _vm._uid } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.transformTranslation(
                                        "Ceres::Template.addressSalutation",
                                        "de",
                                        "delivery_address.salutation"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isInOptionalFields("de", "delivery_address.title")
                    ? _c("div", { staticClass: "col-12 col-sm-4" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate:text",
                                value: _vm.isInRequiredFields(
                                  "de",
                                  "delivery_address.title"
                                ),
                                expression:
                                  "\n                            isInRequiredFields(\n                                'de',\n                                'delivery_address.title'\n                            )\n                        ",
                                arg: "text",
                              },
                            ],
                            staticClass: "input-unit",
                            attrs: { "data-model": "title" },
                          },
                          [
                            _c("input", {
                              attrs: {
                                id: "txtTitle" + _vm._uid,
                                "data-autofocus": "",
                                inputmode: "text",
                                maxlength: "30",
                                name: "title",
                                type: "text",
                              },
                              domProps: { value: _vm.value.title },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInputEvent(
                                    "title",
                                    $event.target.value
                                  )
                                },
                                keypress: function ($event) {
                                  return _vm.filterCharacters($event)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "txtTitle" + _vm._uid } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.transformTranslation(
                                        "Ceres::Template.addressTitle",
                                        "de",
                                        "delivery_address.title"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.areNameFieldsShown("de", "delivery_address")
                    ? [
                        _c("div", { staticClass: "col-12 col-sm-4" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate:text",
                                  value: _vm.areNameFieldsRequired(
                                    "de",
                                    "delivery_address"
                                  ),
                                  expression:
                                    "\n                                areNameFieldsRequired(\n                                    'de',\n                                    'delivery_address'\n                                )\n                            ",
                                  arg: "text",
                                },
                              ],
                              staticClass: "input-unit",
                              class: {
                                "error-without-z":
                                  _vm.isFirstNameValid2 === false,
                                "success-without-z":
                                  _vm.isFirstNameValid2 === true,
                              },
                              attrs: { "data-model": "name2" },
                            },
                            [
                              _c("input", {
                                attrs: {
                                  id: "txtFirstName" + _vm._uid,
                                  "data-autofocus": "",
                                  "data-testing":
                                    "delivery-address-de-firstname",
                                  inputmode: "text",
                                  maxlength: "19",
                                  name: "firstName",
                                  type: "text",
                                },
                                domProps: { value: _vm.value.name2 },
                                on: {
                                  input: function ($event) {
                                    var inputValue = $event.target.value
                                    _vm.emitInputEvent(
                                      "name2",
                                      $event.target.value
                                    )
                                    _vm.clearTimer("FN2")
                                    _vm.setTimer("FN2", function () {
                                      _vm.isAddressEmpty(
                                        inputValue,
                                        "firstName",
                                        2
                                      )
                                    })
                                  },
                                  blur: function ($event) {
                                    _vm.clearTimer("FN2")
                                    _vm.isAddressEmpty(
                                      $event.target.value,
                                      "firstName",
                                      2
                                    )
                                  },
                                  keypress: function ($event) {
                                    return _vm.filterCharacters($event)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "txtFirstName" + _vm._uid } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.addressFirstName"
                                      )
                                    ) + "\n                                "
                                  ),
                                  _vm.areNameFieldsRequired(
                                    "de",
                                    "delivery_address"
                                  )
                                    ? [_vm._v("*")]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-sm-4" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate:text",
                                  value: _vm.areNameFieldsRequired(
                                    "de",
                                    "delivery_address"
                                  ),
                                  expression:
                                    "\n                                areNameFieldsRequired(\n                                    'de',\n                                    'delivery_address'\n                                )\n                            ",
                                  arg: "text",
                                },
                              ],
                              staticClass: "input-unit",
                              class: {
                                "error-without-z":
                                  _vm.isLastNameValid2 === false,
                                "success-without-z":
                                  _vm.isLastNameValid2 === true,
                              },
                              attrs: { "data-model": "name3" },
                            },
                            [
                              _c("input", {
                                attrs: {
                                  id: "txtLastName" + _vm._uid,
                                  "data-testing":
                                    "delivery-address-de-lastname",
                                  inputmode: "text",
                                  maxlength: "19",
                                  name: "lastName",
                                  type: "text",
                                },
                                domProps: { value: _vm.value.name3 },
                                on: {
                                  input: function ($event) {
                                    var inputValue = $event.target.value
                                    _vm.emitInputEvent(
                                      "name3",
                                      $event.target.value
                                    )
                                    _vm.clearTimer("LN2")
                                    _vm.setTimer("LN2", function () {
                                      _vm.isAddressEmpty(
                                        inputValue,
                                        "lastName",
                                        2
                                      )
                                    })
                                  },
                                  blur: function ($event) {
                                    _vm.clearTimer("LN2")
                                    _vm.isAddressEmpty(
                                      $event.target.value,
                                      "lastName",
                                      2
                                    )
                                  },
                                  keypress: function ($event) {
                                    return _vm.filterCharacters($event)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "txtLastName" + _vm._uid } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.addressLastName"
                                      )
                                    ) + "\n                                "
                                  ),
                                  _vm.areNameFieldsRequired(
                                    "de",
                                    "delivery_address"
                                  )
                                    ? [_vm._v("*")]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          ),
                        ]),
                      ]
                    : _c("div", { staticClass: "col-12 col-sm-8" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate:text",
                                value: _vm.isInRequiredFields(
                                  "de",
                                  "delivery_address.contactPerson"
                                ),
                                expression:
                                  "\n                            isInRequiredFields(\n                                'de',\n                                'delivery_address.contactPerson'\n                            )\n                        ",
                                arg: "text",
                              },
                            ],
                            staticClass: "input-unit",
                            attrs: { "data-model": "contactPerson" },
                          },
                          [
                            _c("input", {
                              attrs: {
                                id: "txtContactPerson" + _vm._uid,
                                inputmode: "text",
                                maxlength: "19",
                                name: "lastName",
                                type: "text",
                              },
                              domProps: { value: _vm.value.contactPerson },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInputEvent(
                                    "contactPerson",
                                    $event.target.value
                                  )
                                },
                                keypress: function ($event) {
                                  return _vm.filterCharacters($event)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "txtContactPerson" + _vm._uid } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.transformTranslation(
                                        "Ceres::Template.addressContactPerson",
                                        "de",
                                        "delivery_address.contactPerson"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                  _vm._v(" "),
                  _vm.isInOptionalFields("de", "delivery_address.name4")
                    ? _c("div", { staticClass: "col-12 col-sm-4" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate:text",
                                value: _vm.isInRequiredFields(
                                  "de",
                                  "delivery_address.name4"
                                ),
                                expression:
                                  "\n                            isInRequiredFields(\n                                'de',\n                                'delivery_address.name4'\n                            )\n                        ",
                                arg: "text",
                              },
                            ],
                            staticClass: "input-unit",
                            attrs: { "data-model": "name4" },
                          },
                          [
                            _c("input", {
                              attrs: {
                                id: "txtAdditionalName" + _vm._uid,
                                inputmode: "text",
                                maxlength: "30",
                                name: "decorateName",
                                type: "text",
                              },
                              domProps: { value: _vm.value.name4 },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInputEvent(
                                    "name4",
                                    $event.target.value
                                  )
                                },
                                keypress: function ($event) {
                                  return _vm.filterCharacters($event)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                attrs: { for: "txtAdditionalName" + _vm._uid },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.transformTranslation(
                                        "Ceres::Template.addressAdditionalName",
                                        "de",
                                        "delivery_address.name4"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                (_vm.isInOptionalFields("de", "delivery_address.salutation") &&
                  _vm.value.gender === "company") ||
                (_vm.isInOptionalFields("de", "delivery_address.name1") &&
                  !_vm.isInOptionalFields("de", "delivery_address.salutation"))
                  ? _c("div", { staticClass: "col-12 col-sm-6" }, [
                      _c(
                        "div",
                        {
                          staticClass: "input-unit",
                          class: {
                            "error-without-z":
                              _vm.isCompanyNameValid2 === false,
                            "success-without-z":
                              _vm.isCompanyNameValid2 === true,
                          },
                          attrs: {
                            "data-model": "name1",
                            "data-validate": "text",
                          },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "txtCompany" + _vm._uid,
                              "data-autofocus": "",
                              inputmode: "text",
                              maxlength: "30",
                              name: "company",
                              type: "text",
                            },
                            domProps: { value: _vm.value.name1 },
                            on: {
                              input: function ($event) {
                                _vm.emitInputEvent("name1", $event.target.value)
                                _vm.clearTimer("C2")
                                _vm.setTimer("C2", function () {
                                  _vm.isAddressEmpty(
                                    $event.target.value,
                                    "company",
                                    2
                                  )
                                })
                              },
                              blur: function ($event) {
                                _vm.clearTimer("C2")
                                _vm.isAddressEmpty(
                                  $event.target.value,
                                  "company",
                                  2
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "txtCompany" + _vm._uid } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.addressCompany"
                                  )
                                ) + "*"
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-sm-6" },
                  [
                    _c("vat-id", {
                      attrs: {
                        "is-required": _vm.isInRequiredFields(
                          "de",
                          "delivery_address.vatNumber"
                        ),
                        "selected-country-id": _vm.value.countryId,
                        "show-input":
                          (_vm.isInOptionalFields(
                            "de",
                            "delivery_address.salutation"
                          ) &&
                            _vm.value.gender === "company" &&
                            _vm.isInOptionalFields(
                              "de",
                              "delivery_address.vatNumber"
                            )) ||
                          (!_vm.isInOptionalFields(
                            "de",
                            "delivery_address.salutation"
                          ) &&
                            _vm.isInOptionalFields(
                              "de",
                              "delivery_address.name1"
                            ) &&
                            _vm.isInOptionalFields(
                              "de",
                              "delivery_address.vatNumber"
                            )),
                        value: _vm.value.vatNumber || "",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.emitInputEvent("vatNumber", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-6" }, [
                  _c(
                    "div",
                    {
                      staticClass: "input-unit",
                      class: {
                        "error-without-z": _vm.isStreetNameValid2 === false,
                        "success-without-z": _vm.isStreetNameValid2 === true,
                      },
                      attrs: {
                        "data-model": "address1",
                        "data-validate": "text",
                      },
                    },
                    [
                      _c("input", {
                        attrs: {
                          id: "txtStreet" + _vm._uid,
                          autocomplete: "address-line1",
                          "data-testing": "delivery-address-de-street",
                          inputmode: "text",
                          maxlength: "30",
                          name: "street",
                          type: "text",
                        },
                        domProps: { value: _vm.value.address1 },
                        on: {
                          input: function ($event) {
                            var inputValue = $event.target.value
                            _vm.emitInputEvent("address1", $event.target.value)
                            _vm.clearTimer("SN2")
                            _vm.setTimer("SN2", function () {
                              _vm.isAddressEmpty(inputValue, "street", 2)
                            })
                          },
                          blur: function ($event) {
                            _vm.clearTimer("SN2")
                            _vm.isAddressEmpty($event.target.value, "street", 2)
                          },
                          keypress: function ($event) {
                            return _vm.filterCharacters($event)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "txtStreet" + _vm._uid } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("Ceres::Template.addressStreet")
                          ) + "*"
                        ),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-2" }, [
                  _c(
                    "div",
                    {
                      staticClass: "input-unit",
                      class: {
                        "error-without-z": _vm.isHouseNumberValid2 === false,
                        "success-without-z": _vm.isHouseNumberValid2 === true,
                      },
                      attrs: {
                        "data-model": "address2",
                        "data-validate": "text",
                      },
                    },
                    [
                      _c("input", {
                        attrs: {
                          id: "txtNumber" + _vm._uid,
                          autocomplete: "address-line2",
                          "data-testing": "delivery-address-de-housenumber",
                          inputmode: "text",
                          maxlength: "30",
                          name: "housenumber",
                          type: "text",
                        },
                        domProps: { value: _vm.value.address2 },
                        on: {
                          input: function ($event) {
                            var inputValue = $event.target.value
                            _vm.emitInputEvent("address2", $event.target.value)
                            _vm.clearTimer("HN2")
                            _vm.setTimer("HN2", function () {
                              _vm.isAddressEmpty(inputValue, "houseNumber", 2)
                            })
                          },
                          blur: function ($event) {
                            _vm.clearTimer("HN2")
                            _vm.isAddressEmpty(
                              $event.target.value,
                              "houseNumber",
                              2
                            )
                          },
                          keypress: function ($event) {
                            return _vm.filterCharacters($event)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "txtNumber" + _vm._uid } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("Ceres::Template.addressNumber")
                          ) + "*"
                        ),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _vm.isInOptionalFields("de", "delivery_address.phoneNumber")
                  ? _c("div", { staticClass: "col-4" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate:text",
                              value: _vm.isInRequiredFields(
                                "de",
                                "delivery_address.phoneNumber"
                              ),
                              expression:
                                "\n                            isInRequiredFields(\n                                'de',\n                                'delivery_address.phoneNumber'\n                            )\n                        ",
                              arg: "text",
                            },
                          ],
                          staticClass: "input-unit",
                          attrs: { "data-model": "telephone" },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "txtTelephone" + _vm._uid,
                              inputmode: "tel",
                              maxlength: "30",
                              name: "telephone",
                              type: "tel",
                            },
                            domProps: { value: _vm.value.telephone },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  "telephone",
                                  $event.target.value
                                )
                              },
                              keypress: function ($event) {
                                return _vm.onlyNumbers(
                                  "telephone",
                                  _vm._uid,
                                  $event
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "txtTelephone" + _vm._uid } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.transformTranslation(
                                      "Ceres::Template.addressTelephone",
                                      "de",
                                      "delivery_address.phoneNumber"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _vm.isParcelOrOfficeAvailable
              ? _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("input", {
                        attrs: {
                          id: "showPickup" + _vm._uid,
                          name: "togglePickup",
                          type: "checkbox",
                        },
                        domProps: { checked: _vm.value.showPickupStation },
                        on: {
                          change: function ($event) {
                            return _vm.togglePickupStation(
                              $event.target.checked
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "showPickup" + _vm._uid } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$translate(
                              "Ceres::Template.addressToPickupStation"
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                _vm.isInOptionalFields("de", "delivery_address.address3")
                  ? _c("div", { staticClass: "col-12 col-sm-6" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate:text",
                              value: _vm.isInRequiredFields(
                                "de",
                                "delivery_address.address3"
                              ),
                              expression:
                                "\n                            isInRequiredFields(\n                                'de',\n                                'delivery_address.address3'\n                            )\n                        ",
                              arg: "text",
                            },
                          ],
                          staticClass: "input-unit",
                          attrs: { "data-model": "address3" },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "decorateAddress0" + _vm._uid,
                              inputmode: "text",
                              maxlength: "30",
                              name: "decorateAddress",
                              type: "text",
                            },
                            domProps: { value: _vm.value.address3 },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  "address3",
                                  $event.target.value
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "decorateAddress0" + _vm._uid } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.transformTranslation(
                                      "Ceres::Template.addressAdditionalAddress1",
                                      "de",
                                      "delivery_address.address3"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isInOptionalFields("de", "delivery_address.address4")
                  ? _c("div", { staticClass: "col-12 col-sm-6" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate:text",
                              value: _vm.isInRequiredFields(
                                "de",
                                "delivery_address.address4"
                              ),
                              expression:
                                "\n                            isInRequiredFields(\n                                'de',\n                                'delivery_address.address4'\n                            )\n                        ",
                              arg: "text",
                            },
                          ],
                          staticClass: "input-unit",
                          attrs: { "data-model": "address4" },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "decorateAddress1" + _vm._uid,
                              inputmode: "text",
                              maxlength: "30",
                              name: "decorateAddress",
                              type: "text",
                            },
                            domProps: { value: _vm.value.address4 },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  "address4",
                                  $event.target.value
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "decorateAddress1" + _vm._uid } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.transformTranslation(
                                      "Ceres::Template.addressAdditionalAddress2",
                                      "de",
                                      "delivery_address.address4"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-sm-4" }, [
              _c(
                "div",
                {
                  staticClass: "input-unit",
                  class: {
                    "error-without-z": _vm.isPostalCodeValid2 === false,
                    "success-without-z": _vm.isPostalCodeValid2 === true,
                  },
                  attrs: {
                    "data-model": "postalCode",
                    "data-validate": "postalCode",
                  },
                },
                [
                  _c("input", {
                    staticClass: "postalCodeCustomDelivery",
                    attrs: {
                      id: "txtZip" + _vm._uid,
                      "data-testing": "delivery-address-de-zip",
                      inputmode: "numeric",
                      maxlength: "4",
                      name: "zip",
                      type: "text",
                      pattern: ".{4,4}",
                    },
                    domProps: { value: _vm.value.postalCode },
                    on: {
                      input: function ($event) {
                        var inputValue = $event.target.value
                        _vm.emitInputEvent("postalCode", $event.target.value)
                        _vm.clearTimer("ZIP2")
                        _vm.setTimer("ZIP2", function () {
                          _vm.validatePostalCode(inputValue, 2)
                        })
                      },
                      blur: function ($event) {
                        _vm.clearTimer("ZIP2")
                        _vm.validatePostalCode($event.target.value, 2)
                      },
                      keypress: function ($event) {
                        return _vm.onlyNumbers("postalCode", _vm._uid, $event)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "txtZip" + _vm._uid } }, [
                    _vm._v(
                      _vm._s(_vm.$translate("Ceres::Template.addressZip")) + "*"
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "errTxtZip" + _vm._uid,
                      staticClass:
                        "errmsg test4 text-danger position-absolute small mt-1",
                      staticStyle: { display: "none" },
                      attrs: { id: "errTxtZip" + _vm._uid },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate(
                              "GonserDT::Template.checkoutOnlyNumbers"
                            )
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "errTxtZipLengthDelivery bg-warning p-3" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate(
                              "GonserDT::Template.checkoutZipLength"
                            )
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-sm-4" }, [
              _c(
                "div",
                {
                  staticClass: "input-unit",
                  class: {
                    "error-without-z": _vm.isTownValid2 === false,
                    "success-without-z": _vm.isTownValid2 === true,
                  },
                  attrs: { "data-model": "town", "data-validate": "text" },
                },
                [
                  _c("input", {
                    attrs: {
                      id: "txtPlace" + _vm._uid,
                      "data-testing": "delivery-address-de-town",
                      inputmode: "text",
                      maxlength: "30",
                      name: "town",
                      type: "text",
                    },
                    domProps: { value: _vm.value.town },
                    on: {
                      input: function ($event) {
                        var inputValue = $event.target.value
                        _vm.emitInputEvent("town", $event.target.value)
                        _vm.clearTimer("T2")
                        _vm.setTimer("T2", function () {
                          _vm.isAddressEmpty(inputValue, "town", 2)
                        })
                      },
                      blur: function ($event) {
                        _vm.clearTimer("T2")
                        _vm.isAddressEmpty($event.target.value, "town", 2)
                      },
                      keypress: function ($event) {
                        return _vm.filterCharacters($event)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "txtPlace" + _vm._uid } }, [
                    _vm._v(
                      _vm._s(_vm.$translate("Ceres::Template.addressPlace")) +
                        "*"
                    ),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-12 col-sm-4",
                attrs: { "data-testing": "address-country-select" },
              },
              [
                _c("country-select", {
                  attrs: {
                    "address-type": _vm.addressType,
                    "optional-address-fields": _vm.optionalAddressFields,
                    "required-address-fields": _vm.requiredAddressFields,
                    specificCountryIds: [4, 34],
                    "selected-country-id": _vm.value.countryId,
                    "selected-state-id": _vm.value.stateId,
                  },
                  on: {
                    "country-changed": function ($event) {
                      return _vm.onSelectedCountryChanged($event)
                    },
                    "state-changed": function ($event) {
                      return _vm.emitInputEvent("stateId", $event)
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm._t("custom-address-fields"),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c("hr", { staticClass: "mt-0" }),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _vm.isInOptionalFields("de", "delivery_address.email")
                  ? _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate:text",
                              value: _vm.isInRequiredFields(
                                "de",
                                "delivery_address.email"
                              ),
                              expression:
                                "\n                            isInRequiredFields(\n                                'de',\n                                'delivery_address.email'\n                            )\n                        ",
                              arg: "text",
                            },
                          ],
                          staticClass: "input-unit",
                          attrs: { "data-model": "email" },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "email" + _vm._uid,
                              "data-testing": "delivery-address-de-email-input",
                              inputmode: "email",
                              maxlength: "30",
                              name: "email",
                              type: "mail",
                            },
                            domProps: { value: _vm.value.email },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  "email",
                                  $event.target.value
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "email" + _vm._uid } }, [
                            _vm._v(
                              _vm._s(
                                _vm.transformTranslation(
                                  "Ceres::Template.addressMail",
                                  "de",
                                  "delivery_address.email"
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]
        : _vm.localeToShow == "GB" && _vm.addressType === "2"
        ? [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                _vm.isInOptionalFields("gb", "delivery_address.salutation")
                  ? _c("div", { staticClass: "col-12 col-sm-4" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.isInRequiredFields(
                                "gb",
                                "delivery_address.salutation"
                              ),
                              expression:
                                "\n                            isInRequiredFields(\n                                'gb',\n                                'delivery_address.salutation'\n                            )\n                        ",
                            },
                          ],
                          staticClass: "input-unit",
                        },
                        [
                          _c("salutation-select", {
                            attrs: {
                              id: "txtSalutation" + _vm._uid,
                              "address-data": _vm.value,
                              "address-type": _vm.addressType,
                              "enabled-address-fields":
                                _vm.optionalAddressFields,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  $event.field,
                                  $event.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "txtSalutation" + _vm._uid } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.transformTranslation(
                                      "Ceres::Template.addressSalutation",
                                      "gb",
                                      "delivery_address.salutation"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                (_vm.isInOptionalFields("gb", "delivery_address.salutation") &&
                  _vm.value.gender === "company") ||
                (_vm.isInOptionalFields("gb", "delivery_address.name1") &&
                  !_vm.isInOptionalFields("gb", "delivery_address.salutation"))
                  ? _c("div", { staticClass: "col-12 col-sm-6" }, [
                      _c(
                        "div",
                        {
                          staticClass: "input-unit",
                          attrs: {
                            "data-model": "name1",
                            "data-validate": "text",
                          },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "txtCompany" + _vm._uid,
                              "data-autofocus": "",
                              inputmode: "text",
                              maxlength: "30",
                              name: "company",
                              type: "text",
                            },
                            domProps: { value: _vm.value.name1 },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  "name1",
                                  $event.target.value
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "txtCompany" + _vm._uid } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.addressCompany"
                                  )
                                ) + "*"
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-sm-6" },
                  [
                    _c("vat-id", {
                      attrs: {
                        "is-required": _vm.isInRequiredFields(
                          "gb",
                          "delivery_address.vatNumber"
                        ),
                        "selected-country-id": _vm.value.countryId,
                        "show-input":
                          (_vm.isInOptionalFields(
                            "gb",
                            "delivery_address.salutation"
                          ) &&
                            _vm.value.gender === "company" &&
                            _vm.isInOptionalFields(
                              "gb",
                              "delivery_address.vatNumber"
                            )) ||
                          (!_vm.isInOptionalFields(
                            "gb",
                            "delivery_address.salutation"
                          ) &&
                            _vm.isInOptionalFields(
                              "gb",
                              "delivery_address.name1"
                            ) &&
                            _vm.isInOptionalFields(
                              "gb",
                              "delivery_address.vatNumber"
                            )),
                        value: _vm.value.vatNumber || "",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.emitInputEvent("vatNumber", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c(
                "div",
                { staticClass: "row" },
                [
                  _vm.isInOptionalFields("gb", "delivery_address.title")
                    ? _c("div", { staticClass: "col-12 col-sm-4" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate:text",
                                value: _vm.isInRequiredFields(
                                  "gb",
                                  "delivery_address.title"
                                ),
                                expression:
                                  "\n                            isInRequiredFields(\n                                'gb',\n                                'delivery_address.title'\n                            )\n                        ",
                                arg: "text",
                              },
                            ],
                            staticClass: "input-unit",
                            attrs: { "data-model": "title" },
                          },
                          [
                            _c("input", {
                              attrs: {
                                id: "txtTitle" + _vm._uid,
                                "data-autofocus": "",
                                inputmode: "text",
                                maxlength: "30",
                                name: "title",
                                type: "text",
                              },
                              domProps: { value: _vm.value.title },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInputEvent(
                                    "title",
                                    $event.target.value
                                  )
                                },
                                keypress: function ($event) {
                                  return _vm.filterCharacters($event)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "txtTitle" + _vm._uid } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.transformTranslation(
                                        "Ceres::Template.addressTitle",
                                        "gb",
                                        "delivery_address.title"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.areNameFieldsShown("gb", "delivery_address")
                    ? [
                        _c("div", { staticClass: "col-12 col-sm-4" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate:text",
                                  value: _vm.areNameFieldsRequired(
                                    "gb",
                                    "delivery_address"
                                  ),
                                  expression:
                                    "\n                                areNameFieldsRequired(\n                                    'gb',\n                                    'delivery_address'\n                                )\n                            ",
                                  arg: "text",
                                },
                              ],
                              staticClass: "input-unit",
                              attrs: { "data-model": "name2" },
                            },
                            [
                              _c("input", {
                                attrs: {
                                  id: "txtFirstName" + _vm._uid,
                                  "data-autofocus": "",
                                  inputmode: "text",
                                  maxlength: "19",
                                  name: "firstName",
                                  type: "text",
                                },
                                domProps: { value: _vm.value.name2 },
                                on: {
                                  input: function ($event) {
                                    return _vm.emitInputEvent(
                                      "name2",
                                      $event.target.value
                                    )
                                  },
                                  keypress: function ($event) {
                                    return _vm.filterCharacters($event)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "txtFirstName" + _vm._uid } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.addressFirstName"
                                      )
                                    ) + "\n                                "
                                  ),
                                  _vm.areNameFieldsRequired(
                                    "gb",
                                    "delivery_address"
                                  )
                                    ? [_vm._v("*")]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-sm-4" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate:text",
                                  value: _vm.areNameFieldsRequired(
                                    "gb",
                                    "delivery_address"
                                  ),
                                  expression:
                                    "\n                                areNameFieldsRequired(\n                                    'gb',\n                                    'delivery_address'\n                                )\n                            ",
                                  arg: "text",
                                },
                              ],
                              staticClass: "input-unit",
                              attrs: { "data-model": "name3" },
                            },
                            [
                              _c("input", {
                                attrs: {
                                  id: "txtLastName" + _vm._uid,
                                  inputmode: "text",
                                  maxlength: "19",
                                  name: "lastName",
                                  type: "text",
                                },
                                domProps: { value: _vm.value.name3 },
                                on: {
                                  input: function ($event) {
                                    return _vm.emitInputEvent(
                                      "name3",
                                      $event.target.value
                                    )
                                  },
                                  keypress: function ($event) {
                                    return _vm.filterCharacters($event)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "txtLastName" + _vm._uid } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.addressLastName"
                                      )
                                    ) + "\n                                "
                                  ),
                                  _vm.areNameFieldsRequired(
                                    "gb",
                                    "delivery_address"
                                  )
                                    ? [_vm._v("*")]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          ),
                        ]),
                      ]
                    : _c("div", { staticClass: "col-12 col-sm-8" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate:text",
                                value: _vm.isInRequiredFields(
                                  "gb",
                                  "delivery_address.contactPerson"
                                ),
                                expression:
                                  "\n                            isInRequiredFields(\n                                'gb',\n                                'delivery_address.contactPerson'\n                            )\n                        ",
                                arg: "text",
                              },
                            ],
                            staticClass: "input-unit",
                            attrs: { "data-model": "contactPerson" },
                          },
                          [
                            _c("input", {
                              attrs: {
                                id: "txtContactPerson" + _vm._uid,
                                inputmode: "text",
                                maxlength: "19",
                                name: "lastName",
                                type: "text",
                              },
                              domProps: { value: _vm.value.contactPerson },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInputEvent(
                                    "contactPerson",
                                    $event.target.value
                                  )
                                },
                                keypress: function ($event) {
                                  return _vm.filterCharacters($event)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "txtContactPerson" + _vm._uid } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.transformTranslation(
                                        "Ceres::Template.addressContactPerson",
                                        "gb",
                                        "delivery_address.contactPerson"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                  _vm._v(" "),
                  _vm.isInOptionalFields("gb", "delivery_address.name4")
                    ? _c("div", { staticClass: "col-12 col-sm-4" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate:text",
                                value: _vm.isInRequiredFields(
                                  "gb",
                                  "delivery_address.name4"
                                ),
                                expression:
                                  "\n                            isInRequiredFields(\n                                'gb',\n                                'delivery_address.name4'\n                            )\n                        ",
                                arg: "text",
                              },
                            ],
                            staticClass: "input-unit",
                            attrs: { "data-model": "name4" },
                          },
                          [
                            _c("input", {
                              attrs: {
                                id: "txtAdditionalName" + _vm._uid,
                                inputmode: "text",
                                maxlength: "30",
                                name: "decorateName",
                                type: "text",
                              },
                              domProps: { value: _vm.value.name4 },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInputEvent(
                                    "name4",
                                    $event.target.value
                                  )
                                },
                                keypress: function ($event) {
                                  return _vm.filterCharacters($event)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                attrs: { for: "txtAdditionalName" + _vm._uid },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.transformTranslation(
                                        "Ceres::Template.addressGBNameAffix",
                                        "gb",
                                        "delivery_address.name4"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isInOptionalFields("gb", "delivery_address.phoneNumber")
                    ? _c("div", { staticClass: "col-12 col-sm-4" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate:text",
                                value: _vm.isInRequiredFields(
                                  "gb",
                                  "delivery_address.phoneNumber"
                                ),
                                expression:
                                  "\n                            isInRequiredFields(\n                                'gb',\n                                'delivery_address.phoneNumber'\n                            )\n                        ",
                                arg: "text",
                              },
                            ],
                            staticClass: "input-unit",
                            attrs: { "data-model": "telephone" },
                          },
                          [
                            _c("input", {
                              attrs: {
                                id: "txtTelephone" + _vm._uid,
                                inputmode: "tel",
                                maxlength: "30",
                                name: "telephone",
                                type: "tel",
                              },
                              domProps: { value: _vm.value.telephone },
                              on: {
                                input: function ($event) {
                                  return _vm.emitInputEvent(
                                    "telephone",
                                    $event.target.value
                                  )
                                },
                                keypress: function ($event) {
                                  return _vm.onlyNumbers(
                                    "telephone",
                                    _vm._uid,
                                    $event
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "txtTelephone" + _vm._uid } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.transformTranslation(
                                        "Ceres::Template.addressTelephone",
                                        "gb",
                                        "delivery_address.phoneNumber"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-sm-8" }, [
                  _c(
                    "div",
                    {
                      staticClass: "input-unit",
                      attrs: {
                        "data-model": "address1",
                        "data-validate": "text",
                      },
                    },
                    [
                      _c("input", {
                        attrs: {
                          id: "txtStreet" + _vm._uid,
                          autocomplete: "address-line1",
                          inputmode: "text",
                          maxlength: "30",
                          name: "street",
                          type: "text",
                        },
                        domProps: { value: _vm.value.address1 },
                        on: {
                          input: function ($event) {
                            return _vm.emitInputEvent(
                              "address1",
                              $event.target.value
                            )
                          },
                          keypress: function ($event) {
                            return _vm.filterCharacters($event)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "txtStreet" + _vm._uid } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$translate(
                              "Ceres::Template.addressENAddressLine1"
                            )
                          ) + "*"
                        ),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _vm.isInOptionalFields("gb", "delivery_address.address2")
                  ? _c("div", { staticClass: "col-12 col-sm-12" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate:text",
                              value: _vm.isInRequiredFields(
                                "gb",
                                "delivery_address.address2"
                              ),
                              expression:
                                "\n                            isInRequiredFields(\n                                'gb',\n                                'delivery_address.address2'\n                            )\n                        ",
                              arg: "text",
                            },
                          ],
                          staticClass: "input-unit",
                          attrs: { "data-model": "address2" },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "txtNumber" + _vm._uid,
                              autocomplete: "address-line2",
                              inputmode: "text",
                              maxlength: "30",
                              name: "housenumber",
                              type: "text",
                            },
                            domProps: { value: _vm.value.address2 },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  "address2",
                                  $event.target.value
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "txtNumber" + _vm._uid } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.transformTranslation(
                                      "Ceres::Template.addressENAddressLine2",
                                      "gb",
                                      "delivery_address.address2"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                _vm.isInOptionalFields("gb", "delivery_address.address3")
                  ? _c("div", { staticClass: "col-12 col-sm-6" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate:text",
                              value: _vm.isInRequiredFields(
                                "gb",
                                "delivery_address.address3"
                              ),
                              expression:
                                "\n                            isInRequiredFields(\n                                'gb',\n                                'delivery_address.address3'\n                            )\n                        ",
                              arg: "text",
                            },
                          ],
                          staticClass: "input-unit",
                          attrs: { "data-model": "address3" },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "decorateAddress0" + _vm._uid,
                              inputmode: "text",
                              maxlength: "30",
                              name: "buildingName",
                              type: "text",
                            },
                            domProps: { value: _vm.value.address3 },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  "address3",
                                  $event.target.value
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "decorateAddress0" + _vm._uid } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.transformTranslation(
                                      "Ceres::Template.addressENAddressLine3",
                                      "gb",
                                      "delivery_address.address3"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isInOptionalFields("gb", "delivery_address.address4")
                  ? _c("div", { staticClass: "col-12 col-sm-12" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate:text",
                              value: _vm.isInRequiredFields(
                                "gb",
                                "delivery_address.address4"
                              ),
                              expression:
                                "\n                            isInRequiredFields(\n                                'gb',\n                                'delivery_address.address4'\n                            )\n                        ",
                              arg: "text",
                            },
                          ],
                          staticClass: "input-unit",
                          attrs: { "data-model": "address4" },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "decorateAddress1" + _vm._uid,
                              inputmode: "text",
                              maxlength: "30",
                              name: "buildingName",
                              type: "text",
                            },
                            domProps: { value: _vm.value.address4 },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  "address4",
                                  $event.target.value
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "decorateAddress1" + _vm._uid } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.transformTranslation(
                                      "Ceres::Template.addressENAddressLine4",
                                      "gb",
                                      "delivery_address.address4"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-sm-4" }, [
              _c(
                "div",
                {
                  staticClass: "input-unit",
                  attrs: { "data-model": "town", "data-validate": "text" },
                },
                [
                  _c("input", {
                    attrs: {
                      id: "txtPlace" + _vm._uid,
                      inputmode: "text",
                      maxlength: "30",
                      name: "town",
                      type: "text",
                    },
                    domProps: { value: _vm.value.town },
                    on: {
                      input: function ($event) {
                        return _vm.emitInputEvent("town", $event.target.value)
                      },
                      keypress: function ($event) {
                        return _vm.filterCharacters($event)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "txtPlace" + _vm._uid } }, [
                    _vm._v(
                      _vm._s(_vm.$translate("Ceres::Template.addressPlace")) +
                        "*"
                    ),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-sm-4" }, [
              _c(
                "div",
                {
                  staticClass: "input-unit",
                  attrs: {
                    "data-model": "postalCode",
                    "data-validate": "postalCode",
                  },
                },
                [
                  _c("input", {
                    attrs: {
                      id: "txtZip" + _vm._uid,
                      inputmode: "numeric",
                      maxlength: "4",
                      name: "zip",
                      type: "text",
                      pattern: ".{4,4}",
                    },
                    domProps: { value: _vm.value.postalCode },
                    on: {
                      input: function ($event) {
                        return _vm.emitInputEvent(
                          "postalCode",
                          $event.target.value
                        )
                      },
                      keypress: function ($event) {
                        return _vm.onlyNumbers("postalCode", _vm._uid, $event)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "txtZip" + _vm._uid } }, [
                    _vm._v(
                      _vm._s(_vm.$translate("Ceres::Template.addressZip")) + "*"
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "errTxtZip" + _vm._uid,
                      staticClass:
                        "errmsg test5 text-danger position-absolute small mt-1",
                      staticStyle: { display: "none" },
                      attrs: { id: "errTxtZip" + _vm._uid },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate(
                              "GonserDT::Template.checkoutOnlyNumbers"
                            )
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-12 col-sm-4",
                attrs: { "data-testing": "address-country-select" },
              },
              [
                _c("country-select", {
                  attrs: {
                    "address-type": _vm.addressType,
                    "optional-address-fields": _vm.optionalAddressFields,
                    "required-address-fields": _vm.requiredAddressFields,
                    specificCountryIds: [4, 34],
                    "selected-country-id": _vm.value.countryId,
                    "selected-state-id": _vm.value.stateId,
                  },
                  on: {
                    "country-changed": function ($event) {
                      return _vm.onSelectedCountryChanged($event)
                    },
                    "state-changed": function ($event) {
                      return _vm.emitInputEvent("stateId", $event)
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm._t("custom-address-fields"),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c("hr", { staticClass: "mt-0" }),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _vm.isInOptionalFields("gb", "delivery_address.email")
                  ? _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate:text",
                              value: _vm.isInRequiredFields(
                                "gb",
                                "delivery_address.email"
                              ),
                              expression:
                                "\n                            isInRequiredFields(\n                                'gb',\n                                'delivery_address.email'\n                            )\n                        ",
                              arg: "text",
                            },
                          ],
                          staticClass: "input-unit",
                          attrs: { "data-model": "email" },
                        },
                        [
                          _c("input", {
                            attrs: {
                              id: "email" + _vm._uid,
                              "data-testing": "delivery-address-gb-email-input",
                              inputmode: "email",
                              maxlength: "30",
                              name: "email",
                              type: "mail",
                            },
                            domProps: { value: _vm.value.email },
                            on: {
                              input: function ($event) {
                                return _vm.emitInputEvent(
                                  "email",
                                  $event.target.value
                                )
                              },
                              keypress: function ($event) {
                                return _vm.filterCharacters($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "email" + _vm._uid } }, [
                            _vm._v(
                              _vm._s(
                                _vm.transformTranslation(
                                  "Ceres::Template.addressMail",
                                  "gb",
                                  "delivery_address.email"
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }